const image = {
    bankOfflineStatus: '/public/html/images/bank_img/bank_offline_status.png',
    homeSmallBanner: '/public/html/images/home_img/home-bottom-banner.jpg',
    homeAmbassador: '/public/html/images/footer/Brand-Ambassador-Section.png',
    announcementIconImg: '/public/html/images/common_img/icon_home_notice.png',
    hotIcon: '/public/html/images/home_img/icon-hot.png',
    newIcon: '/public/html/images/home_img/icon-new.png',
    vpnIcon: '/public/html/images/home_img/icon-vpn.png',
    defaultVpnIcon: '/public/html/default_whitelabel/shared-image/icons/vpn-ss2.png',
    hotIconSvg: '/public/html/images/home_img/icon-hot.svg',
    newIconSvg: '/public/html/images/home_img/icon-new.svg',
    vpnIconSvg: '/public/html/images/home_img/icon-vpn.svg',
    pagcorImage: '/public/html/images/home_img/home-service-pagcor.jpg',
    pagcorIcon: '/public/html/images/footer/pagcor_hover.png',
    ezpIcon: '/public/html/images/footer/ftr_pay_eezie_ov.png',
    ssIcon: '/public/html/images/footer/superswan_ov.png',
    ssIconv2: '/public/html/images/footer/superswan-logo.png',
    ssLogo: '/public/html/images/footer/superswan.png',
    chromeFooterIcon: '/public/html/images/footer/ftr_browser_chrome_ov.png',
    ieFooterIcon: '/public/html/images/footer/ftr_browser_ie_ov.png',
    firefoxIcon: '/public/html/images/footer/ftr_browser_ff_ov.png',
    safariIcon: '/public/html/images/footer/ftr_browser_safari_ov.png',
    specialPromoCodeValid: '/public/html/default_whitelabel/shared-image/icons/icon-checked.png',
    specialPromoCodeInvalid: '/public/html/default_whitelabel/shared-image/icons/icon-invalid.png',
    threeLeft: '/public/images/common_img/chevrons-left.svg',
    threeRight: '/public/images/common_img/chevrons-right.svg',
    registerEmail: '/public/html/images/icon/register-mail.png',
    registerContact: '/public/html/images/icon/register-contact.png',
    registerCurrency: '/public/html/images/icon/register-currency.png',
    registerUser: '/public/html/images/icon/register-user.png',
    registerDOB: '/public/html/images/icon/register-dob.png',
    registerPassword: '/public/html/images/icon/register-password.png',
    registerAFF: '/public/html/images/icon/register-affiliate.png',
    registerSuccess: '/public/html/images/register-success.png',
    registerNavigateButton_en: '/public/html/images/register-navigate-en.png',
    registerNavigateButton_th: '/public/html/images/register-navigate-th.png',
    esportOddsBanner: '/public/html/images/home_img/esportBanner.jpg',
    sportPageEsportOddsBanner: '/public/html/images/sports/esportBanner.jpg',
    registerStatCaution: '/public/html/images/icon/icon_reg_stat_caution.png',
    registerStatError: '/public/html/images/icon/icon_reg_stat_false.png',
    registerStatOk: '/public/html/images/icon/icon_reg_stat_true.png',
    downloadBanner: '/public/html/download/img/mobile-bn.jpg',
    downloadSidebannerIcon: '/public/html/images/home_img/download-sidebanner.png',
    contactSidebannerIcon: '/public/html/images/home_img/contact-sidebanner.png',
    homeSportNewImg: '/public/html/images/home_img/home-soccer-matches-bg.jpg',
    mobileProfileImg: '/public/html/images/profile-extra-img.png',
    mobileFundImg: '/public/html/images/account/funds-extra-img.png',
    ezWithdrawalImg: '/public/html/images/ez-withdrawal.png',
    lineLoginLogo: '/public/html/default_whitelabel/shared-image/icons/t-line.png',
    facebookLoginLogo: '/public/images/icon/facebook.png',
    googleLoginLogo: '/public/images/icon/google.png',
    sportNews: '/public/html/images/home_img/sports-new.png',
    headerBanner: '/public/html/images/home_img/header-banner.png',
    livechatLoginRegister: '/public/html/images/home_img/livechat.png',
    homeAppDownload: '/public/html/images/home_img/download.jpg',
    bankStatus: '/public/html/images/home_img/24-7.png',
    progressBar: '/public/html/images/home_img/progress-bar.png',
    navbarLiveChat: '/public/html/images/home_img/chat_icon.png',
    navbarDisplayMainBannerToggleOn: '/public/html/images/home_img/main_banner_display_toggle_icon_on.png',
    navbarDisplayMainBannerToggleOff: '/public/html/images/home_img/main_banner_display_toggle_icon_off.png',

    // svg img
    downloadSidebannerIconSvg: '/public/html/images/home_img/download_svg.svg',
    contactSidebannerIconSvg: '/public/html/images/home_img/contact_us_svg.svg',
    androidSidebannerIconSvg: '/public/html/images/home_img/android.svg',
    iosSidebannerIconSvg: '/public/html/images/home_img/ios.svg',
    ssSVGLogo: '/public/html/images/footer/svg/superswan_logo.svg',
    bluetick: '/public/html/images/footer/svg/bluetick.svg',
    antilephone: '/public/html/images/footer/svg/antilephone_logo.svg',

    imgViewComm: '/public/html/images/livetv/live-commentary-en-6107d4701c.png',
    imgViewStat: '/public/html/images/livetv/live-stat-en-bbf9a7ee9f.png',
    imgLiveTvBanner: '/public/html/images/livetv/livetv-banner.png',
    imgWatchLive: '/public/html/images/livetv/watch_live-en-607f8ab617.png',
    d_imgViewComm: '/public/html/default_whitelabel/default-images/livetv/comment-view.png',
    d_imgViewStat: '/public/html/default_whitelabel/default-images/livetv/live-stat.png',
    d_imgWatchLive: '/public/html/default_whitelabel/default-images/livetv/watch-live.png',
    imgNoLive: '/public/images/livetv/livetv-nomatch-web.png',
    imgNoLiveNew: '/public/html/default_whitelabel/shared-image/liveTV/no-live-matches.png',
    liveTVDefaultHome: '/public/html/images/livetv/livetv_default_home.png',
    liveTVDefaultAway: '/public/html/images/livetv/livetv_default_away.png',
    slotHLUL: ['/public/html/images/slot_img/ultimate-highlight-bn.jpg'],
    slotHLULpng: ['/public/html/images/slot_img/ultimate-highlight-bn.png'],
    vipBottomBanner: ['/public/html/images/home_img/vip-btm.png'],
    defaultTeamHomeImg: ['/public/html/images/team/sportsbook_icon_home.png'],
    defaultTeamAwayImg: ['/public/html/images/team/sportsbook_icon_away.png'],
    defaultPostBanner: ['/public/html/content/sponsors-img/intro-esport.jpg'],
    affAccountBadge: ['/public/html/default_whitelabel/default-images/icon/gold_coin_icon.png'],
    // affAccountBadge: ['/public/html/default_whitelabel_template_images/icon/bk-coin-gold.png'],
    official_link_icon: '/public/html/default_whitelabel/shared-image/icons/icon-link.png',
    m_official_link_icon: '/public/html/default_whitelabel/shared-image/icons/m-icon-link.png',
    dropdown_icon: '/public/html/default_whitelabel/shared-image/icons/nav-lang-arrow.png',

    referralBanner: ['/public/html/images/home_img/referral-banner.jpg'],
    referralContent: ['/public/html/images/home_img/referral-content.png'],
    referralContent2: ['/public/html/images/home_img/referral-content2.png'],
    mreferralIcon: ['/public/html/images/home_img/m-referral-icon.png'],
    referralIcon: ['/public/html/images/home_img/referral-icon.png'],
    share: ['/public/html/default_whitelabel/shared-image/icons/link-share.png'],
    line: ['/public/html/images/icon/line.png'],
    fb: ['/public/html/images/icon/fb.png'],
    instagram: ['/public/html/images/icon/instagram.png'],
    whatsapp: ['/public/html/images/icon/whatsapp.png'],
    zalo: ['/public/html/images/icon/zalo.png'],
    telegram: ['/public/html/images/icon/telegram.png'],
    email: ['/public/html/images/icon/email.png'],
    skype: ['/public/html/images/icon/skype.png'],

    sponsorsBanner: ['/public/html/images/home_img/sponsorsBanner.png'],
    sponsorsIcon1: ['/public/html/images/home_img/sponsorsIcon1.png'],
    sponsorsIcon2: ['/public/html/images/home_img/sponsorsIcon2.png'],
    sponsorsIcon3: ['/public/html/images/home_img/sponsorsIcon3.png'],
    sponsorsLogo: ['/public/html/images/home_img/logo.png'],

    imgBankStatus: '/public/html/images/bank_img/bankstatus.png',
    footer18Icon: '/public/html/images/footer/18_only.png',
    top_restore_icon: '/public/html/images/restore-wallet.png',
    announcement_header_icon: '/public/html/images/icon/announcement_logo.png',
    announcement_header_icon2: '/public/html/images/icon/announcement_logo.gif',
    vipHotIcon: '/public/html/images/home_img/vip-hot-icon.gif',
    phone_verified_icon: '/public/html/images/icon/phone-verified.png?',
    phone_unverified_icon: '/public/html/images/icon/phone-unverified.png?',

    // rai88 special image
    specialPromo: '/public/html/images/footer/special-promo.png',
    specialTips: '/public/html/images/footer/special-tips.png',
    specialVip: '/public/html/images/footer/special-vip.png',
    specialDeposit: '/public/html/images/footer/special-deposit.png',
    specialFB: '/public/html/images/footer/special-fb.png',
    specialYTB: '/public/html/images/footer/special-ytb.png',
    specialIG: '/public/html/images/footer/special-ig.png',
    specialTWIT: '/public/html/images/footer/special-twit.png',

    liveCasinoImgIcon: '/public/html/images/home_img/home_icon_livecasino.png',

    //uea aff img
    faqDropdownArrow: '/public/html/images/icon/arrow.png',

    // bonus indicator
    bonusLock: '/public/html/default_whitelabel/shared-image/icons/lock.svg',
    bonusCoin: '/public/html/default_whitelabel/shared-image/icons/coin.png',

    LINE_DEPOSIT_BANNER: {
        desktop: '/public/html/images/bank_img/line.png',
        desktop_line_click: '/public/html/images/bank_img/line_click_logo.png',
        mobile_side_bar: '/public/html/images/home_img/lineIcon.png',
        mobile1: '/public/html/images/bank_img/line_mobile01.png',
        mobile2: '/public/html/images/bank_img/line_mobile02.png',
        mobile3: '/public/html/images/bank_img/line_mobile03.png',
        mobile4: '/public/html/images/bank_img/line_mobile04.png',
    },
    PROVIDER_ICON: {
        // slot
        ag: '/public/html/images/icon/provider-ag.png',
        ag2: '/public/html/images/icon/provider-ag.png',
        mega: '/public/html/images/icon/provider_mega888.png',
        mgp: '/public/html/images/icon/provider-mg.png',
        mgp2: '/public/html/images/icon/provider-mg.png',
        ns: '/public/html/images/icon/provider-ns.png',
        pg: '/public/html/images/icon/provider-pg.png',
        pt: '/public/html/images/icon/provider-pt.png',
        pt2: '/public/html/images/icon/provider-pt.png',
        pt3: '/public/html/images/icon/provider-pt.png',
        pt4: '/public/html/images/icon/provider-pt.png',
        pt5: '/public/html/images/icon/provider-pt.png',
        ptl: '/public/html/images/icon/provider-pt.png',
        ptl4: '/public/html/images/icon/provider-pt.png',
        ptl5: '/public/html/images/icon/provider-pt.png',
        pp: '/public/html/images/icon/provider-pragmaticplay.png',
        sa: '/public/html/images/icon/provider-asiagaming.png',
        scr2: '/public/html/images/icon/provider_918kiss.png',
        sg: '/public/html/images/icon/provider-spade.png',
        ttg: '/public/html/images/icon/provider-ttg.png',
        ug: '/public/html/images/icon/provider-aesexy.png',
        aes: '/public/html/images/icon/provider-aesexy.png',
        ul: '/public/html/images/icon/provider-ultimate.png',
        hs: '/public/html/images/icon/provider-hs.png',
        // IME
        ime: '/public/html/images/icon/provider-ultimate.png',
        // Casino
        ab: '/public/html/images/icon/provider-allbet.png',
        bmk: '/public/html/images/icon/provider-evo.png',
        ebet: '/public/html/images/icon/provider-ebet.png',
        dg: '/public/html/images/icon/provider-dreamgaming.png',
        gp: '/public/html/images/icon/provider-gp.png',
        // Fishing
        gg: '/public/html/images/icon/provider-gg.png',
        // Sport
        cmd: '/public/html/images/icon/provider-cmd.png',
        ibc: '/public/html/images/icon/.png',
        br: '/public/html/images/icon/.png',
        m8: '/public/html/images/icon/provider-m8bet.png',
        // poker
        idn: '/public/html/images/icon/provider-idnpoker.png',
        // Lottery
        qqk: '/public/html/images/icon/provider-qqkeno.png',
        km: '/public/html/images/icon/provider-km.png',
        fg: '/public/html/images/icon/provider-fg.png',
        kms: '/public/html/images/icon/provider-kms.png',

        hotmatch: ['/public/html/images/home_img/home_icon_hotmatch.png'],
        homeLiveIcon: ['/public/html/images/home_img/home-live-icon.png'],
        homeMatchIcon: ['/public/html/images/home_img/home-match-icon.png'],
    },
    NAV_ICON: {
        hot: '/public/html/images/slot_img/hot.png',
        all: '/public/html/images/slot_img/all.png',
        new: '/public/html/images/slot_img/NewMember.png',
        slot: '/public/html/images/slot_img/Slot.png',
        arcade: '/public/html/images/slot_img/Casino.png',
        table: '/public/html/images/slot_img/Lottery.png',
        special: '/public/html/images/slot_img/Special.png',
        vip: '/public/html/images/slot_img/VIP.png',
        sports: '/public/html/images/slot_img/Sportbook.png',
        winner: '/public/html/images/slot_img/Winner.png',
        html5: '/public/html/images/slot_img/html5.png',
        esports: '/public/html/images/slot_img/esports.png',
        fishing: '/public/html/images/slot_img/fishing.png',
        live: '/public/html/default_whitelabel/shared-image/icons/menu_icon_live.gif',
        slice: '/public/html/images/home_img/menu-slice.png',
        isHot: '/public/html/images/drawer_img/menu_icon_hot.gif',
        isNew: '/public/html/images/drawer_img/menu_icon_new.png',
        isVpn: '/public/html/images/drawer_img/menu_icon_vpn.png',
        isNewBeta: '/public/html/images/drawer_img/menu_icon_new.svg',
        isNewEN: '/public/html/images/drawer_img/menu_icon_new_en.png',
        isNewCN: '/public/html/images/drawer_img/menu_icon_new_cn.png',
        isNewMS: '/public/html/images/drawer_img/menu_icon_new_ms.png',
        vip_menu: '/public/html/images/drawer_img/vip-menu.png',
        vip_menu_on: '/public/html/images/drawer_img/vip-menu-on.png',
    },
    HOME_TITLE_BG: {
        hotgame: '/public/html/images/home_img/hotgame_title_bg.png',
        hotgame_hover: '/public/html/images/home_img/hotgame_title_bg_hover.png',
        hotgame_border: '/public/html/images/home_img/hotgame_border.png',
        livecasino: '/public/html/images/home_img/livecasino_title_bg.png',
        livecasino_hover: '/public/html/images/home_img/livecasino_title_bg_hover.png',
        livecasino_border: '/public/html/images/home_img/livecasino_border.png',
        hotmatch: '/public/html/images/home_img/hotmatch_title_bg.png',
        hotmatch_hover: '/public/html/images/home_img/hotmatch_title_bg_on.png',
        hotmatch_border: '/public/html/images/home_img/hotmatch_border.png',
    },
    PROMO_NAV_ICON: {
        hot: '/public/html/images/slot_img/hot.png',
        all: '/public/html/images/drawer_img/Promo.png',
        new: '/public/html/images/drawer_img/NewMember.png',
        slot: '/public/html/images/drawer_img/Slots.png',
        arcade: '/public/html/images/drawer_img/Casino.png',
        table: '/public/html/images/drawer_img/Lottery_1.png',
        special: '/public/html/images/drawer_img/Special.png',
        vip: '/public/html/images/drawer_img/VIP.png',
        sports: '/public/html/images/drawer_img/Sport.png',
        winner: '/public/html/images/drawer_img/VIP.png',
        html5: '/public/html/images/slot_img/html5.png',
        esports: '/public/html/images/drawer_img/esport.png',
        fishing: '/public/html/images/drawer_img/Fishing.png',
        live: '/public/html/images/drawer_img/menu_icon_live.gif',
        slice: '/public/html/images/home_img/menu-slice.png',
    },
    FISHING_BANNER: {
        index: {
            bannerAlt1: ['fishing-bn'],
            banner1: ['/public/html/images/fishing/fishing-bn.jpg'],
        },
        ambs: { banner1: ['/public/html/images/fishing/fishing-bn-askmeslot.jpg'] },
        cashfish: {
            bannerAlt1: ['fishing-bn-pt'],
            banner1: ['/public/html/images/fishing/fishing-bn-pt.jpg'],
            bannerAlt2: ['fishing-feature-pt'],
            banner2: ['/public/html/images/fishing/fishing-highlight-pt.jpg'],
            banner2png: ['/public/html/images/fishing/fishing-highlight-pt.png'],
        },
        gggaming: {
            bannerAlt1: ['fishing-bn-gg'],
            banner1: ['/public/html/images/fishing/fishing-bn-gg.jpg'],
            bannerAlt2: ['fishing-feature-gg'],
            banner2: ['/public/html/images/fishing/fishing-highlight-gg.jpg'],
            banner2png: ['/public/html/images/fishing/fishing-highlight-gg.png'],
        },
        safishing: {
            bannerAlt1: ['fishing-bn-sa'],
            banner1: ['/public/html/images/fishing/fishing-bn-sa.jpg'],
            bannerAlt2: ['fishing-feature-sa'],
            banner2: ['/public/html/images/fishing/fishing-highlight-sa.jpg'],
            banner2png: ['/public/html/images/fishing/fishing-highlight-sa.png'],
        },
        sgfishing: {
            bannerAlt1: ['fishing-bn-fg'],
            banner1: ['/public/html/images/fishing/fishing-bn-sg.jpg'],
            bannerAlt2: ['fishing-feature-fg'],
            banner2: ['/public/html/images/fishing/fishing-highlight-sg.jpg'],
            banner2png: ['/public/html/images/fishing/fishing-highlight-sg.png'],
        },
        spadegamingfishinggod: {
            bannerAlt1: ['fishing-bn-fg'],
            banner1: ['/public/html/images/fishing/fishing-bn-sg.jpg'],
            bannerAlt2: ['fishing-feature-fg'],
            banner2: ['/public/html/images/fishing/fishing-highlight-sg.jpg'],
            banner2png: ['/public/html/images/fishing/fishing-highlight-sg.png'],
        },
        sgfishingwar: {
            bannerAlt1: ['fishing-bn-fw'],
            banner1: ['/public/html/images/fishing/fishing-bn-fw.jpg'],
            bannerAlt2: ['fishing-feature-fw'],
            banner2: ['/public/html/images/fishing/fishing-highlight-fw.jpg'],
            banner2png: ['/public/html/images/fishing/fishing-highlight-fw.png'],
        },
        spadegamingfishingwar: {
            bannerAlt1: ['fishing-bn-fw'],
            banner1: ['/public/html/images/fishing/fishing-bn-fw.jpg'],
            bannerAlt2: ['fishing-feature-fw'],
            banner2: ['/public/html/images/fishing/fishing-highlight-fw.jpg'],
            banner2png: ['/public/html/images/fishing/fishing-highlight-fw.png'],
        },
        spadeGaming: {
            bannerAlt1: ['fishing-bn-fg'],
            banner1: ['/public/html/images/fishing/fishing-bn-sg.jpg'],
            bannerAlt2: ['fishing-feature-fg'],
            banner2: ['/public/html/images/fishing/fishing-highlight-sg.jpg'],
            banner2png: ['/public/html/images/fishing/fishing-highlight-sg.png'],
        },
        jili: {
            bannerAlt1: ['fishing-bn-jili'],
            banner1: ['/public/html/images/fishing/fishing-bn-jili.jpg'],
            bannerAlt2: ['fishing-feature-jili'],
            banner2: ['/public/html/images/fishing/fishing-highlight-jili.jpg'],
            banner2png: ['/public/html/images/fishing/fishing-highlight-jili.png'],
        },
        minited: {
            bannerAlt1: ['fishing-bn-mt'],
            banner1: ['/public/html/images/fishing/fishing-bn-mt.jpg'],
            bannerAlt2: ['fishing-feature-mt'],
            banner2: ['/public/html/images/fishing/fishing-highlight-mt.jpg'],
            banner2png: ['/public/html/images/fishing/fishing-highlight-mt.png'],
        },
        royalslotgaming: {
            bannerAlt1: ['fishing-bn-rsg'],
            banner1: ['/public/html/images/fishing/fishing-bn-rsg.jpg'],
            bannerAlt2: ['fishing-feature-rsg'],
            banner2: ['/public/html/images/fishing/fishing-highlight-rsg.jpg'],
            banner2png: ['/public/html/images/fishing/fishing-highlight-rsg.png'],
        },
        nextspin: {
            bannerAlt1: ['fishing-bn-ns'],
            banner1: ['/public/html/images/fishing/fishing-bn-ns.jpg'],
            bannerAlt2: ['fishing-feature-ns'],
            banner2: ['/public/html/images/fishing/fishing-highlight-ns.jpg'],
            banner2png: ['/public/html/images/fishing/fishing-highlight-ns.png'],
        },
        yesgetrich: {
            bannerAlt1: ['fishing-bn-ygs'],
            banner1: ['/public/html/images/fishing/fishing-bn-ygs.jpg'],
            bannerAlt2: ['fishing-feature-ygs'],
            banner2: ['/public/html/images/fishing/fishing-highlight-ygs.jpg'],
            banner2png: ['/public/html/images/fishing/fishing-highlight-ygs.png'],
        },
        cq9: {
            bannerAlt1: ['fishing-bn-cq9'],
            banner1: ['/public/html/images/fishing/fishing-bn-cq9.jpg'],
            bannerAlt2: ['fishing-feature-cq9'],
            banner2: ['/public/html/images/fishing/fishing-highlight-cq9.jpg'],
            banner2png: ['/public/html/images/fishing/fishing-highlight-cq9.png'],
        },
        fachai: {
            bannerAlt1: ['fishing-bn-fc'],
            banner1: ['/public/html/images/fishing/fishing-bn-fc.jpg'],
            bannerAlt2: ['fishing-feature-fc'],
            banner2: ['/public/html/images/fishing/fishing-highlight-fc.jpg'],
            banner2png: ['/public/html/images/fishing/fishing-highlight-fc.png'],
        },
        joker: {
            bannerAlt1: ['fishing-bn-joker'],
            banner1: ['/public/html/images/fishing/fishing-bn-joker.jpg'],
            bannerAlt2: ['fishing-feature-joker'],
            banner2: ['/public/html/images/fishing/fishing-highlight-joker.jpg'],
            banner2png: ['/public/html/images/fishing/fishing-highlight-joker.png'],
        },
        playstar: {
            bannerAlt1: ['fishing-bn-playstar'],
            banner1: ['/public/html/images/fishing/fishing-bn-playstar.jpg'],
            bannerAlt2: ['fishing-feature-playstar'],
            banner2: ['/public/html/images/fishing/fishing-highlight-playstar.jpg'],
            banner2png: ['/public/html/images/fishing/fishing-highlight-playstar.png'],
        },
        vp: {
            bannerAlt1: ['fishing-bn-vp'],
            banner1: ['/public/html/images/fishing/fishing-bn-vp.jpg'],
        },
        // reference: default-whitelabel\settings\base-menu.json: 1593
        jdbgaming: {
            bannerAlt1: ['fishing-bn-jdb'],
            banner1: ['/public/html/images/fishing/fishing-bn-jdb.jpg'],
            bannerAlt2: ['fishing-feature-jdb'],
            banner2: ['/public/html/images/fishing/fishing-highlight-jdb.jpg'],
            banner2png: ['/public/html/images/fishing/fishing-highlight-jdb.png'],
        },
        jdbgaming2: {
            bannerAlt1: ['fishing-bn-jdb'],
            banner1: ['/public/html/images/fishing/fishing-bn-jdb.jpg'],
            bannerAlt2: ['fishing-feature-jdb'],
            banner2: ['/public/html/images/fishing/fishing-highlight-jdb.jpg'],
            banner2png: ['/public/html/images/fishing/fishing-highlight-jdb.png'],
        },
        Spinix: {
            bannerAlt1: ['fishing-bn-spx'],
            banner1: ['/public/html/images/fishing/fishing-bn-spx.jpg'],
            bannerAlt2: ['fishing-feature-spx'],
            banner2: ['/public/html/images/fishing/fishing-highlight-spx.jpg'],
            banner2png: ['/public/html/images/fishing/fishing-highlight-spx.png'],
        },
        fs: { banner1: ['/public/html/images/fishing/fishing-bn-fs.jpg'] },
        r88: { banner1: ['/public/html/images/fishing/fishing-bn-r88.jpg'] },
        yb: { banner1: ['/public/html/images/fishing/fishing-bn-yb.jpg'] },
        l365: { banner1: ['/public/html/images/fishing/fishing-bn-l365.jpg'] },
        aw: { banner1: ['/public/html/images/fishing/fishing-bn-aw.jpg'] },
    },
    FASTGAMES_BANNER: {
        spb: { banner: ['/public/html/images/fastgames_img/fastgames-bn-spb.jpg'] },
        jl: { banner: ['/public/html/images/fastgames_img/fastgames-bn-jili.jpg'] },
        avx: { banner: ['/public/html/images/fastgames_img/fastgames-bn-aviatrix.jpg'] },
        ms: { banner: ['/public/html/images/fastgames_img/fastgames-bn-ms.jpg'] },
    },
    POKER_BANNER: {
        poker: {
            desktop: {
                bannerAlt1: ['poker-bn-idn'],
                banner1: ['/public/html/images/poker/poker-bn.jpg'],
                banner1png: ['/public/html/images/poker/poker-bn.png'],
                bannerAlt2: ['poker-bn-2'],
                banner2: ['/public/html/images/poker/poker-highlight-bn.jpg'],
                banner2png: ['/public/html/images/poker/poker-highlight-bn.png'],
                bottom: ['/public/html/images/poker/poker-bottom.png'],
            },
            mobile: {
                bannerAlt1: ['poker-idn-logo'],
                banner1: ['/public/html/images/cat_img/cat_poker_idn_logo.png'],
                bannerAlt2: ['mobile-banner-idnplay'],
                banner2: ['/public/html/images/poker/mobile_banner_idnplay.jpg'],
                banner2png: ['/public/html/images/poker/mobile_banner_idnplay.png'],
            },
        },
        idn: {
            desktop: {
                bannerAlt1: ['poker-bn-idn'],
                banner1: ['/public/html/images/poker/poker-bn.jpg'],
                bannerAlt2: ['poker-bn-2'],
                banner2: ['/public/html/images/poker/poker-highlight-bn.jpg'],
                banner2png: ['/public/html/images/poker/poker-highlight-bn.png'],
            },
            mobile: {
                bannerAlt1: ['poker-idn-logo'],
                banner1: ['/public/html/images/cat_img/cat_poker_idn_logo.png'],
                bannerAlt2: ['mobile-banner-idnplay'],
                banner2: ['/public/html/images/poker/mobile_banner_idnplay.jpg'],
                banner2png: ['/public/html/images/poker/mobile_banner_idnplay.png'],
            },
        },
        t7: {
            desktop: {},
            mobile: {
                banner1: ['/public/html/images/cat_img/cat_poker_t7_logo.png'],
                banner2: ['/public/html/images/poker/mobile_banner_t7.jpg'],
            },
        },
        jili: {
            desktop: {
                banner1: ['/public/html/images/poker/jili-bn.jpg'],
                banner2: ['/public/html/images/poker/jili-bn.jpg'],
                banner2png: ['/public/html/images/poker/jili-bn.jpg'],
            },
            mobile: {
                banner1: ['/public/html/images/cat_img/cat_poker_jili_logo.png'],
                banner2: ['/public/html/images/poker/mobile_banner_jili.jpg'],
            },
        },
        kypoker: {
            desktop: {
                banner1: ['/public/html/images/poker/kyp-bn.jpg'],
                banner2: ['/public/html/images/poker/kyp-bn.jpg'],
                banner2png: ['/public/html/images/poker/kyp-bn.jpg'],
            },
            mobile: {
                banner1: ['/public/html/images/cat_img/cat_poker_kyp_logo.png'],
                banner2: ['/public/html/images/poker/mobile_banner_kyp.jpg'],
            },
        },
        defaultBanner: '/public/html/images/poker/poker-bn.jpg',
    },
    POKER_BANNER_LANG: {
        banner_top: {
            zh: ['/public/html/images/poker/poker_banner_top_cn.jpg'],
            en: ['/public/html/images/poker/poker_banner_top_en.jpg'],
            ms: ['/public/html/images/poker/poker_banner_top_my.jpg'],
        },
        banner_center: {
            zh: ['/public/html/images/poker/poker_banner_center_cn.jpg'],
            en: ['/public/html/images/poker/poker_banner_center_en.jpg'],
            ms: ['/public/html/images/poker/poker_banner_center_my.jpg'],
        },
        banner_bottom: {
            zh: ['/public/html/images/poker/poker_banner_bottom_cn.jpg'],
            en: ['/public/html/images/poker/poker_banner_bottom_en.jpg'],
            ms: ['/public/html/images/poker/poker_banner_bottom_my.jpg'],
        },
        defaultBanner: '/public/html/images/fishing/fishing-bn.jpg',
    },
    SLOT_IMAGE: {
        commonBanner: ['/public/html/images/slot_img/common-bn.png'],
        slotWinnerIcon: ['/public/html/images/slot_img/slot_icon_winner.png'],
        slotSpadeIcon: ['/public/html/images/slot_img/Slot-spade.png'],
        slotSpadeIconHome: ['/public/html/images/slot_img/Slot-spade-home.png'],
        slotCurrencyIcon: ['/public/html/images/slot_img/slot-currency.png'],
        defaultSlotImg: ['/public/html/images/slot_img/default-img.png'],
        asiagaming: { banner1: ['/public/html/images/slot_img/slot-bn-ag.jpg'] },
        gameplay: { banner1: ['/public/html/images/slot_img/slot-bn-gp.jpg'] },
        mega888: { banner1: [''] },
        microGamingPlus: { banner1: ['/public/html/images/slot_img/slot-bn-mg.jpg'] },
        microGamingPlus2: { banner1: ['/public/html/images/slot_img/slot-bn-mg.jpg'] },
        microGaming: { banner1: ['/public/html/images/slot_img/slot-bn-mg.jpg'] },
        microgaming: { banner1: ['/public/html/images/slot_img/slot-bn-mg.jpg'] },
        nextspin: { banner1: ['/public/html/images/slot_img/slot-bn-ns.jpg'] },
        playNGo: { banner1: ['/public/html/images/slot_img/slot-bn-pg.jpg'] },
        playTech: { banner1: ['/public/html/images/slot_img/slot-bn-pt.jpg'] },
        pragmaticPlay: { banner1: ['/public/html/images/slot_img/slot-bn-pp.jpg'] },
        saGaming: { banner1: ['/public/html/images/slot_img/slot-bn-sa.jpg'] },
        spadeGaming: { banner1: ['/public/html/images/slot_img/slot-bn-sg.jpg'] },
        toptrendgaming: { banner1: ['/public/html/images/slot_img/slot-bn-ttg.jpg'] },
        ultimateslots: {
            banner1: ['/public/html/images/slot_img/ultimate-bn.jpg'],
            banner2: ['/public/html/images/slot_img/ultimate-highlight-bn.jpg'],
            banner2png: ['/public/html/images/slot_img/ultimate-highlight-bn.png'],
        },
        asiagaming2: { banner1: ['/public/html/images/slot_img/slot-bn-ag.jpg'] },
        pgsoft: { banner1: ['/public/html/images/slot_img/slot-bn-pgsoft.jpg'] },
        pgsoft3: { banner1: ['/public/html/images/slot_img/slot-bn-pgsoft.jpg'] },
        funkygames: { banner1: ['/public/html/images/slot_img/slot-bn-funkygames.jpg'] },
        joker: { banner1: ['/public/html/images/slot_img/slot-bn-joker.jpg'] },
        habanero: { banner1: ['/public/html/images/slot_img/slot-bn-hb.jpg'] },
        netent: { banner1: ['/public/html/images/slot_img/slot-bn-netent.jpg'] },
        ambs: { banner1: ['/public/html/images/slot_img/slot-bn-askmeslot.jpg'] },
        jili: { banner1: ['/public/html/images/slot_img/slot-bn-jili.jpg'] },
        redtiger: { banner1: ['/public/html/images/slot_img/slot-bn-rt.jpg'] },
        rt2: { banner1: ['/public/html/images/slot_img/slot-bn-rt.jpg'] },
        hcslot: { banner1: ['/public/html/images/slot_img/slot-bn-hc.jpg'] },
        minited: { banner1: ['/public/html/images/slot_img/slot-bn-mt.jpg'] },
        royalslotgaming: { banner1: ['/public/html/images/slot_img/slot-bn-rsg.jpg'] },
        pussy888: { banner1: ['/public/html/images/slot_img/slot-bn-psy8.jpg'] },
        ygr: { banner1: ['/public/html/images/slot_img/slot-bn-ygr.jpg'] },
        cq9: { banner1: ['/public/html/images/slot_img/slot-bn-cq9.jpg'] },
        fc: { banner1: ['/public/html/images/slot_img/slot-bn-fc.jpg'] },
        bins2: { banner1: ['/public/html/images/slot_img/slot-bn-bins.jpg'] },
        spb: { banner1: ['/public/html/images/slot_img/slot-bn-spb.jpg'] },
        ps: { banner1: ['/public/html/images/slot_img/slot-bn-ps.jpg'] },
        playstar: { banner1: ['/public/html/images/slot_img/slot-bn-playstar.jpg'] },
        // reference: default-whitelabel\settings\base-menu.json: 1137
        jdb: {
            banner1: ['/public/html/images/slot_img/slot-bn-jdb.jpg'],
        },
        jdb2: {
            banner1: ['/public/html/images/slot_img/slot-bn-jdb.jpg'],
        },
        rg: {
            banner1: ['/public/html/images/slot_img/slot-bn-rg.jpg'],
        },
        ygg: {
            banner1: ['/public/html/images/slot_img/slot-bn-ygg.jpg'],
        },
        pgslot: {
            banner1: ['/public/html/images/slot_img/slot-bn-pgs2.jpg'],
        },
        Spinix: { banner1: ['/public/html/images/slot_img/slot-bn-spinix.jpg'] },
        ap: {
            banner1: ['/public/html/images/slot_img/slot-bn-ap.jpg'],
        },
        vp: { banner1: ['/public/html/images/slot_img/slot-bn-vp.jpg'] },
        ep: {
            banner1: ['/public/html/images/slot_img/slot-bn-ep.jpg'],
        },
        fs: { banner1: ['/public/html/images/slot_img/slot-bn-fs.jpg'] },
        nlc: { banner1: ['/public/html/images/slot_img/slot-bn-nlc.jpg'] },
        r88: { banner1: ['/public/html/images/slot_img/slot-bn-r88.jpg'] },
        weslt: { banner1: ['/public/html/images/slot_img/slot-bn-weslt.jpg'] },
        hs: { banner1: ['/public/html/images/slot_img/slot-bn-hs.jpg'] },
        hs2: { banner1: ['/public/html/images/slot_img/slot-bn-hs2.jpg'] },
        bng: { banner1: ['/public/html/images/slot_img/slot-bn-bng.jpg'] },
        yb: { banner1: ['/public/html/images/slot_img/slot-bn-yb.jpg'] },
        atg: { banner1: ['/public/html/images/slot_img/slot-bn-atg.jpg'] },
        l365: { banner1: ['/public/html/images/slot_img/slot-bn-l365.jpg'] },
        aw: { banner1: ['/public/html/images/slot_img/slot-bn-aw.jpg'] },
        ew: { banner1: ['/public/html/images/slot_img/slot-bn-ew.jpg'] },
        ibex: { banner1: ['/public/html/images/slot_img/slot-bn-ibex.jpg'] },
        ilu: { banner1: ['/public/html/images/slot_img/slot-bn-ilu.jpg'] },
        g168: { banner1: ['/public/html/images/slot_img/slot-bn-g168.jpg'] },
        playTech5: { banner1: ['/public/html/images/slot_img/slot-bn-pt.jpg'] },
        idn2:  { banner1: ['/public/html/images/slot_img/slot-bn-idn2.jpg'] },
        ms: { banner1: ['/public/html/images/slot_img/slot-bn-ms.jpg'] },
        cpg: { banner1: ['/public/html/images/slot_img/slot-bn-cpg.jpg'] },
        pgsm: { banner1: ['/public/html/images/slot_img/slot-bn-pgsm.jpg']},
        vtp: { banner1: ['/public/html/images/slot_img/slot-bn-vtp.jpg'] },
        pop: { banner1: ['/public/html/images/slot_img/slot-bn-pop.jpg'] },
    },
    CASINO_BANNER: {
        cbx: {
            desktop: {
                bannerAlt1: ['casino-bn-cbx'],
                banner1: ['/public/html/images/casino/casino-bn-cbx.jpg'],
                bannerAlt2: ['casino-highlight-cbx'],
                banner2: ['/public/html/images/casino/casino-highlight-cbx.jpg'],
                banner2png: ['/public/html/images/casino/casino-highlight-cbx.png'],
            },
            mobile: {
                bannerAlt1: ['casino-logo-cbx'],
                banner1: ['/public/html/images/cat_img/cat-casino-logo-cbx.png'],
                bannerAlt2: ['casino-mobile-cbx'],
                banner2: ['/public/html/images/cat_img/casino_mobile_cbx.jpg'],
                banner2png: ['/public/html/images/cat_img/casino_mobile_cbx.png'],
            },
        },
        chg: {
            desktop: {
                bannerAlt1: ['casino-bn-chg'],
                banner1: ['/public/html/images/casino/casino-bn-chg.jpg'],
                bannerAlt2: ['casino-highlight-chg'],
                banner2: ['/public/html/images/casino/casino-highlight-chg.jpg'],
                banner2png: ['/public/html/images/casino/casino-highlight-chg.png'],
            },
            mobile: {
                bannerAlt1: ['casino-logo-chg'],
                banner1: ['/public/html/images/cat_img/cat-casino-logo-chg.png'],
                bannerAlt2: ['casino-mobile-chg'],
                banner2: ['/public/html/images/cat_img/casino_mobile_chg.jpg'],
                banner2png: ['/public/html/images/cat_img/casino_mobile_chg.png'],
            },
        },

        eeai: {
            desktop: {
                bannerAlt1: ['casino-bn-eeai'],
                banner1: ['/public/html/images/casino/casino-bn-eeai.jpg'],
                bannerAlt2: ['casino-highlight-eeai'],
                banner2: ['/public/html/images/casino/casino-highlight-eeai.jpg'],
                banner2png: ['/public/html/images/casino/casino-highlight-eeai.png'],
            },
            mobile: {
                bannerAlt1: ['casino-logo-eeai'],
                banner1: ['/public/html/images/cat_img/cat-casino-logo-eeai.png'],
                bannerAlt2: ['casino-mobile-eeai'],
                banner2: ['/public/html/images/cat_img/casino_mobile_eeai.jpg'],
                banner2png: ['/public/html/images/cat_img/casino_mobile_eeai.png'],
            },
        },
        playtechLive5: {
            desktop: {
                bannerAlt1: ['casino-bn-ptl'],
                banner1: ['/public/html/images/casino/casino-bn-ptl.jpg'],
                bannerAlt2: ['casino-feature-ptl'],
                banner2: ['/public/html/images/casino/casino-highlight-ptl.jpg'],
                banner2png: ['/public/html/images/casino/casino-highlight-ptl.png'],
            },
            mobile: {
                bannerAlt1: ['casino-logo-ptl'],
                banner1: ['/public/html/images/cat_img/cat-casino-logo-ptl.png'],
                bannerAlt2: ['casino-mobile-ptl'],
                banner2: ['/public/html/images/cat_img/casino_mobile_ptl.jpg'],
                banner2png: ['/public/html/images/cat_img/casino_mobile_ptl.png'],
            },
        },
        sagaming: {
            desktop: {
                bannerAlt1: ['casino-bn-sa'],
                banner1: ['/public/html/images/casino/casino-bn-sa.jpg'],
                bannerAlt2: ['casino-feature-sa'],
                banner2: ['/public/html/images/casino/casino-highlight-sa.jpg'],
                banner2png: ['/public/html/images/casino/casino-highlight-sa.png'],
            },
            mobile: {
                bannerAlt1: ['casino-logo-sa'],
                banner1: ['/public/html/images/cat_img/cat-casino-logo-sa.png'],
                bannerAlt2: ['casino-mobile-sa'],
                banner2: ['/public/html/images/cat_img/casino_mobile_sa.jpg'],
                banner2png: ['/public/html/images/cat_img/casino_mobile_sa.png'],
            },
            backgroundCasino: {
                background01: ['/public/html/images/casino/livecasinoBg.png'],
            },
        },
        dreamgaming: {
            desktop: {
                bannerAlt1: ['casino-bn-dg'],
                banner1: ['/public/html/images/casino/casino-bn-dg.jpg'],
                bannerAlt2: ['casino-feature-dg'],
                banner2: ['/public/html/images/casino/casino-highlight-dg.jpg'],
                banner2png: ['/public/html/images/casino/casino-highlight-dg.png'],
            },
            mobile: {
                bannerAlt1: ['casino-logo-dg'],
                banner1: ['/public/html/images/cat_img/cat-casino-logo-dg.png'],
                bannerAlt2: ['casino-mobile-dg'],
                banner2: ['/public/html/images/cat_img/casino_mobile_dg.jpg'],
                banner2png: ['/public/html/images/cat_img/casino_mobile_dg.png'],
            },
        },
        asiagaming: {
            desktop: {
                bannerAlt1: ['casino-bn-ag'],
                banner1: ['/public/html/images/casino/casino-bn-ag.jpg'],
                bannerAlt2: ['casino-highlight-ag'],
                banner2: ['/public/html/images/casino/casino-highlight-ag.jpg'],
                banner2png: ['/public/html/images/casino/casino-highlight-ag.png'],
            },
            mobile: {
                bannerAlt1: ['casino-logo-ag'],
                banner1: ['/public/html/images/cat_img/cat-casino-logo-ag.png'],
                bannerAlt2: ['casino-mobile-ag'],
                banner2: ['/public/html/images/cat_img/casino_mobile_ag.jpg'],
                banner2png: ['/public/html/images/cat_img/casino_mobile_ag.png'],
            },
        },
        asiagaming2: {
            desktop: {
                bannerAlt1: ['casino-bn-ag'],
                banner1: ['/public/html/images/casino/casino-bn-ag.jpg'],
                bannerAlt2: ['casino-highlight-ag'],
                banner2: ['/public/html/images/casino/casino-highlight-ag.jpg'],
                banner2png: ['/public/html/images/casino/casino-highlight-ag.png'],
            },
            mobile: {
                bannerAlt1: ['casino-logo-ag'],
                banner1: ['/public/html/images/cat_img/cat-casino-logo-ag.png'],
                bannerAlt2: ['casino-mobile-ag'],
                banner2: ['/public/html/images/cat_img/casino_mobile_ag.jpg'],
                banner2png: ['/public/html/images/cat_img/casino_mobile_ag.png'],
            },
        },
        sexybaccarat: {
            desktop: {
                bannerAlt1: ['casino-bn-aesexy'],
                banner1: ['/public/html/images/casino/casino-bn-aesexy.jpg'],
                bannerAlt2: ['casino-highlight-aesexy'],
                banner2: ['/public/html/images/casino/casino-highlight-aesexy.jpg'],
                banner2png: ['/public/html/images/casino/casino-highlight-aesexy.png'],
            },
            mobile: {
                bannerAlt1: ['casino-logo-aesexy'],
                banner1: ['/public/html/images/cat_img/cat-casino-logo-aesexy.png'],
                bannerAlt2: ['casino-mobile-aesexy'],
                banner2: ['/public/html/images/cat_img/casino_mobile_aesexy.jpg'],
                banner2png: ['/public/html/images/cat_img/casino_mobile_aesexy.png'],
            },
        },
        sexybaccarat2: {
            desktop: {
                bannerAlt1: ['casino-bn-aesexy'],
                banner1: ['/public/html/images/casino/casino-bn-aesexy.jpg'],
                bannerAlt2: ['casino-highlight-aesexy'],
                banner2: ['/public/html/images/casino/casino-highlight-aesexy.jpg'],
                banner2png: ['/public/html/images/casino/casino-highlight-aesexy.png'],
            },
            mobile: {
                bannerAlt1: ['casino-logo-aesexy'],
                banner1: ['/public/html/images/cat_img/cat-casino-logo-aesexy.png'],
                bannerAlt2: ['casino-mobile-aesexy'],
                banner2: ['/public/html/images/cat_img/casino_mobile_aesexy.jpg'],
                banner2png: ['/public/html/images/cat_img/casino_mobile_aesexy.png'],
            },
        },
        easexybaccarat: {
            desktop: {
                bannerAlt1: ['casino-bn-aesexy'],
                banner1: ['/public/html/images/casino/casino-bn-aesexy.jpg'],
                bannerAlt2: ['casino-highlight-aesexy'],
                banner2: ['/public/html/images/casino/casino-highlight-aesexy.jpg'],
                banner2png: ['/public/html/images/casino/casino-highlight-aesexy.png'],
            },
            mobile: {
                bannerAlt1: ['casino-logo-aesexy'],
                banner1: ['/public/html/images/cat_img/cat-casino-logo-aesexy.png'],
                bannerAlt2: ['casino-mobile-aesexy'],
                banner2: ['/public/html/images/cat_img/casino_mobile_aesexy.jpg'],
                banner2png: ['/public/html/images/cat_img/casino_mobile_aesexy.png'],
            },
        },
        ebet: {
            desktop: {
                bannerAlt1: ['casino-bn-ebet'],
                banner1: ['/public/html/images/casino/casino-bn-ebet.jpg'],
                bannerAlt2: ['casino-highlight-ebet'],
                banner2: ['/public/html/images/casino/casino-highlight-ebet.jpg'],
                banner2png: ['/public/html/images/casino/casino-highlight-ebet.png'],
            },
            mobile: {
                bannerAlt1: ['casino-logo-ebet'],
                banner1: ['/public/html/images/cat_img/cat_casino_ebet.png'],
                bannerAlt2: ['casino-mobile-ebet'],
                banner2: ['/public/html/images/cat_img/casino_mobile_ebet.jpg'],
                banner2png: ['/public/html/images/cat_img/casino_mobile_ebet.png'],
            },
        },
        allbet: {
            desktop: {
                bannerAlt1: ['casino-bn-allbet'],
                banner1: ['/public/html/images/casino/casino-bn-allbet.jpg'],
                bannerAlt2: ['casino-highlight-allbet'],
                // galleryBanner: [
                //     "/public/html/images/casino/casino-allbet-hall-dragon.jpg",
                //     "/public/html/images/casino/casino-allbet-hall-multi.jpg",
                //     "/public/html/images/casino/casino-allbet-hall-vip.jpg",
                //     "/public/html/images/casino/casino-allbet-hall-bmq.jpg"
                // ]
                galleryBanner: [
                    {
                        id: '1',
                        banner: '/public/html/images/casino/casino-allbet-hall-dragon.jpg',
                        setBanner: 'C-AB-Gallery-dragon.jpg',
                        translation: 'casino:casino.ab.ab-dragon-hall',
                    },
                    {
                        id: '2',
                        banner: '/public/html/images/casino/casino-allbet-hall-multi.jpg',
                        setBanner: 'C-AB-Gallery-multi.jpg',
                        translation: 'casino:casino.ab.ab-multiplay-hall',
                    },
                    {
                        id: '3',
                        banner: '/public/html/images/casino/casino-allbet-hall-vip.jpg',
                        setBanner: 'C-AB-Gallery-vip.jpg',
                        translation: 'casino:casino.ab.ab-vip-hall',
                    },
                    {
                        id: '4',
                        banner: '/public/html/images/casino/casino-allbet-hall-bmq.jpg',
                        setBanner: 'C-AB-Gallery-bmq.jpg',
                        translation: 'casino:casino.ab.ab-bmq-hall',
                    },
                ],
            },
            mobile: {
                bannerAlt1: ['casino-logo-allbet'],
                banner1: ['/public/html/images/cat_img/cat-casino-logo-allbet.png'],
                bannerAlt2: ['casino-mobile-allbet'],
                banner2: ['/public/html/images/cat_img/casino_mobile_allbet.jpg'],
                banner2png: ['/public/html/images/cat_img/casino_mobile_allbet.png'],
            },
        },
        allbet2: {
            desktop: {
                bannerAlt1: ['casino-bn-allbet'],
                banner1: ['/public/html/images/casino/casino-bn-allbet.jpg'],
                bannerAlt2: ['casino-highlight-allbet'],
                // galleryBanner: [
                //     "/public/html/images/casino/casino-allbet-hall-dragon.jpg",
                //     "/public/html/images/casino/casino-allbet-hall-multi.jpg",
                //     "/public/html/images/casino/casino-allbet-hall-vip.jpg",
                //     "/public/html/images/casino/casino-allbet-hall-bmq.jpg"
                // ]
                galleryBanner: [
                    {
                        id: '1',
                        banner: '/public/html/images/casino/casino-allbet-hall-dragon.jpg',
                        setBanner: 'C-AB-Gallery-dragon.jpg',
                        translation: 'casino:casino.ab.ab-dragon-hall',
                    },
                    {
                        id: '2',
                        banner: '/public/html/images/casino/casino-allbet-hall-multi.jpg',
                        setBanner: 'C-AB-Gallery-multi.jpg',
                        translation: 'casino:casino.ab.ab-multiplay-hall',
                    },
                    {
                        id: '3',
                        banner: '/public/html/images/casino/casino-allbet-hall-vip.jpg',
                        setBanner: 'C-AB-Gallery-vip.jpg',
                        translation: 'casino:casino.ab.ab-vip-hall',
                    },
                    {
                        id: '4',
                        banner: '/public/html/images/casino/casino-allbet-hall-bmq.jpg',
                        setBanner: 'C-AB-Gallery-bmq.jpg',
                        translation: 'casino:casino.ab.ab-bmq-hall',
                    },
                ],
            },
            mobile: {
                bannerAlt1: ['casino-logo-allbet'],
                banner1: ['/public/html/images/cat_img/cat-casino-logo-allbet.png'],
                bannerAlt2: ['casino-mobile-allbet'],
                banner2: ['/public/html/images/cat_img/casino_mobile_allbet.jpg'],
                banner2png: ['/public/html/images/cat_img/casino_mobile_allbet.png'],
            },
        },
        evolutiongaming: {
            desktop: {
                bannerAlt1: ['casino-bn-evo'],
                banner1: ['/public/html/images/casino/casino-bn-evo.jpg'],
                bannerAlt2: ['casino-highlight-evo'],
                banner2: ['/public/html/images/casino/casino-highlight-evo.jpg'],
                banner2png: ['/public/html/images/casino/casino-highlight-evo.png'],
            },
            mobile: {
                bannerAlt1: ['casino-logo-evo'],
                banner1: ['/public/html/images/cat_img/cat-casino-logo-evo.png'],
                bannerAlt2: ['casino-mobile-evo'],
                banner2: ['/public/html/images/cat_img/casino_mobile_evo.jpg'],
                banner2png: ['/public/html/images/cat_img/casino_mobile_evo.png'],
            },
        },
        gameplay: {
            desktop: {
                bannerAlt1: ['casino-bn-gp'],
                banner1: ['/public/html/images/casino/casino-bn-gp.jpg'],
                bannerAlt2: ['casino-highlight-gp'],
                banner2: ['/public/html/images/casino/casino-highlight-gp.jpg'],
                banner2png: ['/public/html/images/casino/casino-highlight-gp.png'],
            },
            mobile: {
                bannerAlt1: ['casino-logo-gp'],
                banner1: ['/public/html/images/cat_img/cat-casino-logo-gp.png'],
                bannerAlt2: ['casino-mobile-gp'],
                banner2: ['/public/html/images/cat_img/casino_mobile_gp.jpg'],
                banner2png: ['/public/html/images/cat_img/casino_mobile_gp.png'],
            },
        },
        playtech: {
            desktop: {
                bannerAlt1: ['casino-bn-pt'],
                banner1: ['/public/html/images/casino/casino-bn-pt.jpg'],
                bannerAlt2: ['casino-highlight-pt'],
                banner2: ['/public/html/images/casino/casino-highlight-pt.jpg'],
                banner2png: ['/public/html/images/casino/casino-highlight-pt.png'],
            },
            mobile: {
                bannerAlt1: ['casino-logo-pt'],
                banner1: ['/public/html/images/cat_img/cat-casino-logo-pt.png'],
                bannerAlt2: ['casino-mobile-pt'],
                banner2: ['/public/html/images/cat_img/casino_mobile_pt.jpg'],
                banner2png: ['/public/html/images/cat_img/casino_mobile_pt.png'],
            },
        },
        playtechLive4: {
            desktop: {
                bannerAlt1: ['casino-bn-pt'],
                banner1: ['/public/html/images/casino/casino-bn-pt.jpg'],
                bannerAlt2: ['casino-highlight-pt'],
                banner2: ['/public/html/images/casino/casino-highlight-pt.jpg'],
                banner2png: ['/public/html/images/casino/casino-highlight-pt.png'],
            },
            mobile: {
                bannerAlt1: ['casino-logo-pt'],
                banner1: ['/public/html/images/cat_img/cat-casino-logo-pt.png'],
                bannerAlt2: ['casino-mobile-pt'],
                banner2: ['/public/html/images/cat_img/casino_mobile_pt.jpg'],
                banner2png: ['/public/html/images/cat_img/casino_mobile_pt.png'],
            },
        },
        ptl4: {
            desktop: {
                bannerAlt1: ['casino-bn-pt'],
                banner1: ['/public/html/images/casino/casino-bn-pt.jpg'],
                bannerAlt2: ['casino-highlight-pt'],
                banner2: ['/public/html/images/casino/casino-highlight-pt.jpg'],
                banner2png: ['/public/html/images/casino/casino-highlight-pt.png'],
            },
            mobile: {
                bannerAlt1: ['casino-logo-pt'],
                banner1: ['/public/html/images/cat_img/cat-casino-logo-pt.png'],
                bannerAlt2: ['casino-mobile-pt'],
                banner2: ['/public/html/images/cat_img/casino_mobile_pt.jpg'],
                banner2png: ['/public/html/images/cat_img/casino_mobile_pt.png'],
            },
        },
        Microgaming: {
            explaination: 'mgp = mg, and most of the merchant de image is mg lagi',
            desktop: {
                bannerAlt1: ['casino-bn-mgp'],
                banner1: ['/public/html/images/casino/casino-bn-mg.jpg'],
                bannerAlt2: ['casino-highlight-mgp'],
                banner2: ['/public/html/images/casino/casino-highlight-mg.jpg'],
                banner2png: ['/public/html/images/casino/casino-highlight-mg.png'],
            },
            mobile: {
                bannerAlt1: ['casino-logo-mgp'],
                banner1: ['/public/html/images/cat_img/cat-casino-logo-mg.png'],
                bannerAlt2: ['casino-mobile-mgp'],
                banner2: ['/public/html/images/cat_img/casino_mobile_mg.jpg'],
                banner2png: ['/public/html/images/cat_img/casino_mobile_mg.png'],
            },
        },
        microGamingPlus: {
            explaination: 'mgp = mg, and most of the merchant de image is mg lagi',
            desktop: {
                bannerAlt1: ['casino-bn-mgp'],
                banner1: ['/public/html/images/casino/casino-bn-mg.jpg'],
                bannerAlt2: ['casino-highlight-mgp'],
                banner2: ['/public/html/images/casino/casino-highlight-mg.jpg'],
                banner2png: ['/public/html/images/casino/casino-highlight-mg.png'],
            },
            mobile: {
                bannerAlt1: ['casino-logo-mgp'],
                banner1: ['/public/html/images/cat_img/cat-casino-logo-mg.png'],
                bannerAlt2: ['casino-mobile-mgp'],
                banner2: ['/public/html/images/cat_img/casino_mobile_mg.jpg'],
                banner2png: ['/public/html/images/cat_img/casino_mobile_mg.png'],
            },
        },
        microGamingPlus2: {
            explaination: 'mgp = mg, and most of the merchant de image is mg lagi',
            desktop: {
                bannerAlt1: ['casino-bn-mgp'],
                banner1: ['/public/html/images/casino/casino-bn-mg.jpg'],
                bannerAlt2: ['casino-highlight-mgp'],
                banner2: ['/public/html/images/casino/casino-highlight-mg.jpg'],
                banner2png: ['/public/html/images/casino/casino-highlight-mg.png'],
            },
            mobile: {
                bannerAlt1: ['casino-logo-mgp'],
                banner1: ['/public/html/images/cat_img/cat-casino-logo-mg.png'],
                bannerAlt2: ['casino-mobile-mgp'],
                banner2: ['/public/html/images/cat_img/casino_mobile_mg.jpg'],
                banner2png: ['/public/html/images/cat_img/casino_mobile_mg.png'],
            },
        },
        gdgaming: {
            desktop: {
                bannerAlt1: ['casino-bn-gd'],
                banner1: ['/public/html/images/casino/casino-bn-gd.jpg'],
                bannerAlt2: ['casino-highlight-gd'],
                banner2: ['/public/html/images/casino/casino-highlight-gd.jpg'],
                banner2png: ['/public/html/images/casino/casino-highlight-gd.png'],
            },
            mobile: {
                bannerAlt1: ['casino-logo-gd'],
                banner1: ['/public/html/images/cat_img/cat-casino-logo-gd.png'],
                bannerAlt2: ['casino-mobile-gd'],
                banner2: ['/public/html/images/cat_img/casino_mobile_gd.jpg'],
                banner2png: ['/public/html/images/cat_img/casino_mobile_gd.png'],
            },
        },
        wm: {
            desktop: {
                bannerAlt1: ['casino-bn-wm'],
                banner1: ['/public/html/images/casino/casino-bn-wm.jpg'],
                bannerAlt2: ['casino-highlight-wm'],
                banner2: ['/public/html/images/casino/casino-highlight-wm.jpg'],
                banner2png: ['/public/html/images/casino/casino-highlight-wm.png'],
            },
            mobile: {
                bannerAlt1: ['casino-logo-wm'],
                banner1: ['/public/html/images/cat_img/cat-casino-logo-wm.png'],
                bannerAlt2: ['casino-mobile-wm'],
                banner2: ['/public/html/images/cat_img/casino_mobile_wm.jpg'],
                banner2png: ['/public/html/images/cat_img/casino_mobile_wm.png'],
            },
        },
        wmcasino: {
            desktop: {
                bannerAlt1: ['casino-bn-wm'],
                banner1: ['/public/html/images/casino/casino-bn-wm.jpg'],
                bannerAlt2: ['casino-highlight-wm'],
                banner2: ['/public/html/images/casino/casino-highlight-wm.jpg'],
                banner2png: ['/public/html/images/casino/casino-highlight-wm.png'],
            },
            mobile: {
                bannerAlt1: ['casino-logo-wm'],
                banner1: ['/public/html/images/cat_img/cat-casino-logo-wm.png'],
                bannerAlt2: ['casino-mobile-wm'],
                banner2: ['/public/html/images/cat_img/casino_mobile_wm.jpg'],
                banner2png: ['/public/html/images/cat_img/casino_mobile_wm.png'],
            },
        },
        w: {
            desktop: {
                bannerAlt1: ['casino-bn-w'],
                banner1: ['/public/html/images/casino/casino-bn-w.jpg'],
                bannerAlt2: ['casino-highlight-wm'],
                banner2: ['/public/html/images/casino/casino-highlight-w.jpg'],
                banner2png: ['/public/html/images/casino/casino-highlight-w.png'],
            },
            mobile: {
                bannerAlt1: ['casino-logo-w'],
                banner1: ['/public/html/images/cat_img/cat-casino-logo-w.png'],
                bannerAlt2: ['casino-mobile-w'],
                banner2: ['/public/html/images/cat_img/casino_mobile_w.jpg'],
                banner2png: ['/public/html/images/cat_img/casino_mobile_w.png'],
            },
        },
        ppl: {
            desktop: {
                bannerAlt1: ['casino-bn-ppl'],
                banner1: ['/public/html/images/casino/casino-bn-ppl.jpg'],
                bannerAlt2: ['casino-highlight-ppl'],
                banner2: ['/public/html/images/casino/casino-highlight-ppl.jpg'],
                banner2png: ['/public/html/images/casino/casino-highlight-ppl.png'],
            },
            mobile: {
                bannerAlt1: ['casino-logo-ppl'],
                banner1: ['/public/html/images/cat_img/cat-casino-logo-ppl.png'],
                bannerAlt2: ['casino-mobile-ppl'],
                banner2: ['/public/html/images/cat_img/casino_mobile_ppl.jpg'],
                banner2png: ['/public/html/images/cat_img/casino_mobile_ppl.jpg'],
            },
        },
        pragmaticplay: {
            desktop: {
                bannerAlt1: ['casino-bn-ppl'],
                banner1: ['/public/html/images/casino/casino-bn-ppl.jpg'],
                bannerAlt2: ['casino-highlight-ppl'],
                banner2: ['/public/html/images/casino/casino-highlight-ppl.jpg'],
                banner2png: ['/public/html/images/casino/casino-highlight-ppl.png'],
            },
            mobile: {
                bannerAlt1: ['casino-logo-ppl'],
                banner1: ['/public/html/images/cat_img/cat-casino-logo-ppl.png'],
                bannerAlt2: ['casino-mobile-ppl'],
                banner2: ['/public/html/images/cat_img/casino_mobile_ppl.jpg'],
                banner2png: ['/public/html/images/cat_img/casino_mobile_ppl.jpg'],
            },
        },
        biggaming: {
            desktop: {
                bannerAlt1: ['casino-bn-bg'],
                banner1: ['/public/html/images/casino/casino-bn-bg.jpg'],
                bannerAlt2: ['casino-highlight-bg'],
                banner2: ['/public/html/images/casino/casino-highlight-bg.jpg'],
                banner2png: ['/public/html/images/casino/casino-highlight-bg.png'],
            },
            mobile: {
                bannerAlt1: ['casino-logo-bg'],
                banner1: ['/public/html/images/cat_img/cat-casino-logo-bg.png'],
                bannerAlt2: ['casino-mobile-bg'],
                banner2: ['/public/html/images/cat_img/casino_mobile_bg.jpg'],
                banner2png: ['/public/html/images/cat_img/casino_mobile_bg.jpg'],
            },
        },
        rt: {
            desktop: {
                bannerAlt1: ['casino-bn-rt'],
                banner1: ['/public/html/images/casino/casino-bn-rt.jpg'],
                bannerAlt2: ['casino-highlight-rt'],
                banner2: ['/public/html/images/casino/casino-highlight-rt.jpg'],
                banner2png: ['/public/html/images/casino/casino-highlight-rt.png'],
            },
            mobile: {
                bannerAlt1: ['casino-logo-rt'],
                banner1: ['/public/html/images/cat_img/cat-casino-logo-rt.png'],
                bannerAlt2: ['casino-mobile-rt'],
                banner2: ['/public/html/images/cat_img/casino_mobile_rt.jpg'],
                banner2png: ['/public/html/images/cat_img/casino_mobile_rt.png'],
            },
        },
        binl2: {
            desktop: {
                bannerAlt1: ['casino-bn-binl'],
                banner1: ['/public/html/images/casino/casino-bn-binl.jpg'],
                bannerAlt2: ['casino-highlight-binl'],
                banner2: ['/public/html/images/casino/casino-highlight-binl.jpg'],
                banner2png: ['/public/html/images/casino/casino-highlight-binl.png'],
            },
            mobile: {
                bannerAlt1: ['casino-logo-binl'],
                banner1: ['/public/html/images/cat_img/cat-casino-logo-binl.png'],
                bannerAlt2: ['casino-mobile-binl'],
                banner2: ['/public/html/images/cat_img/casino_mobile_binl.jpg'],
                banner2png: ['/public/html/images/cat_img/casino_mobile_binl.png'],
            },
        },
        viacasino: {
            desktop: {
                bannerAlt1: ['casino-bn-vc'],
                banner1: ['/public/html/images/casino/casino-bn-vc.jpg'],
                bannerAlt2: ['casino-highlight-vc'],
                banner2: ['/public/html/images/casino/casino-highlight-vc.jpg'],
                banner2png: ['/public/html/images/casino/casino-highlight-vc.png'],
            },
            mobile: {
                bannerAlt1: ['casino-logo-vc'],
                banner1: ['/public/html/images/cat_img/cat-casino-logo-vc.png'],
                bannerAlt2: ['casino-mobile-vc'],
                banner2: ['/public/html/images/cat_img/casino_mobile_vc.jpg'],
                banner2png: ['/public/html/images/cat_img/casino_mobile_vc.png'],
            },
        },
        we: {
            desktop: {
                bannerAlt1: ['casino-bn-we'],
                banner1: ['/public/html/images/casino/casino-bn-we.jpg'],
                bannerAlt2: ['casino-highlight-we'],
                banner2: ['/public/html/images/casino/casino-highlight-we.jpg'],
                banner2png: ['/public/html/images/casino/casino-highlight-we.png'],
            },
            mobile: {
                bannerAlt1: ['casino-logo-we'],
                banner1: ['/public/html/images/cat_img/cat-casino-logo-we.png'],
                bannerAlt2: ['casino-mobile-we'],
                banner2: ['/public/html/images/cat_img/casino_mobile_we.jpg'],
                banner2png: ['/public/html/images/cat_img/casino_mobile_we.png'],
            },
        },
        ybl: {
            desktop: {
                bannerAlt1: ['casino-bn-ybl'],
                banner1: ['/public/html/images/casino/casino-bn-ybl.jpg'],
                bannerAlt2: ['casino-highlight-ybl'],
                banner2: ['/public/html/images/casino/casino-highlight-ybl.jpg'],
                banner2png: ['/public/html/images/casino/casino-highlight-ybl.png'],
            },
            mobile: {
                bannerAlt1: ['casino-logo-ybl'],
                banner1: ['/public/html/images/cat_img/cat-casino-logo-ybl.png'],
                bannerAlt2: ['casino-mobile-ybl'],
                banner2: ['/public/html/images/cat_img/casino_mobile_ybl.jpg'],
                banner2png: ['/public/html/images/cat_img/casino_mobile_ybl.png'],
            },
        },
        ez: {
            desktop: {
                bannerAlt1: ['casino-bn-ez'],
                banner1: ['/public/html/images/casino/casino-bn-ez.jpg'],
                bannerAlt2: ['casino-highlight-ez'],
                banner2: ['/public/html/images/casino/casino-highlight-ez.jpg'],
                banner2png: ['/public/html/images/casino/casino-highlight-ez.png'],
            },
            mobile: {
                bannerAlt1: ['casino-logo-ez'],
                banner1: ['/public/html/images/cat_img/cat-casino-logo-ez.png'],
                bannerAlt2: ['casino-mobile-ez'],
                banner2: ['/public/html/images/cat_img/casino_mobile_ez.jpg'],
                banner2png: ['/public/html/images/cat_img/casino_mobile_ez.png'],
            },
        },
        mtv: {
            desktop: {
                bannerAlt1: ['casino-bn-mtv'],
                banner1: ['/public/html/images/casino/casino-bn-mtv.jpg'],
                bannerAlt2: ['casino-highlight-mtv'],
                banner2: ['/public/html/images/casino/casino-highlight-mtv.jpg'],
                banner2png: ['/public/html/images/casino/casino-highlight-mtv.png'],
            },
            mobile: {
                bannerAlt1: ['casino-logo-mtv'],
                banner1: ['/public/html/images/cat_img/cat-casino-logo-mtv.png'],
                bannerAlt2: ['casino-mobile-mtv'],
                banner2: ['/public/html/images/cat_img/casino_mobile_mtv.jpg'],
                banner2png: ['/public/html/images/cat_img/casino_mobile_mtv.png'],
            },
        },
        motivation: {
            desktop: {
                bannerAlt1: ['casino-bn-mtv'],
                banner1: ['/public/html/images/casino/casino-bn-mtv.jpg'],
                bannerAlt2: ['casino-highlight-mtv'],
                banner2: ['/public/html/images/casino/casino-highlight-mtv.jpg'],
                banner2png: ['/public/html/images/casino/casino-highlight-mtv.png'],
            },
            mobile: {
                bannerAlt1: ['casino-logo-mtv'],
                banner1: ['/public/html/images/cat_img/cat-casino-logo-mtv.png'],
                bannerAlt2: ['casino-mobile-mtv'],
                banner2: ['/public/html/images/cat_img/casino_mobile_mtv.jpg'],
                banner2png: ['/public/html/images/cat_img/casino_mobile_mtv.png'],
            },
        },
        onc: {
            desktop: {
                bannerAlt1: ['casino-bn-onc'],
                banner1: ['/public/html/images/casino/casino-bn-onc.jpg'],
                bannerAlt2: ['casino-highlight-wm'],
                banner2: ['/public/html/images/casino/casino-highlight-onc.jpg'],
                banner2png: ['/public/html/images/casino/casino-highlight-onc.png'],
            },
            mobile: {
                bannerAlt1: ['casino-logo-onc'],
                banner1: ['/public/html/images/cat_img/cat-casino-logo-onc.png'],
                bannerAlt2: ['casino-mobile-onc'],
                banner2: ['/public/html/images/cat_img/casino_mobile_onc.jpg'],
                banner2png: ['/public/html/images/cat_img/casino_mobile_onc.png'],
            },
        },
        prettygaming: {
            desktop: {
                bannerAlt1: ['casino-bn-ptg'],
                banner1: ['/public/html/images/casino/casino-bn-ptg.jpg'],
                bannerAlt2: ['casino-highlight-ptg'],
                banner2: ['/public/html/images/casino/casino-highlight-ptg.jpg'],
                banner2png: ['/public/html/images/casino/casino-highlight-ptg.png'],
            },
            mobile: {
                bannerAlt1: ['casino-logo-ptg'],
                banner1: ['/public/html/images/cat_img/cat-casino-logo-ptg.png'],
                bannerAlt2: ['casino-mobile-ptg'],
                banner2: ['/public/html/images/cat_img/casino_mobile_ptg.jpg'],
                banner2png: ['/public/html/images/cat_img/casino_mobile_ptg.png'],
            },
        },
        idn2: {
            desktop: {
                bannerAlt1: ['casino-bn-idn2'],
                banner1: ['/public/html/images/casino/casino-bn-idn2.jpg'],
                bannerAlt2: ['casino-highlight-idn2'],
                banner2: ['/public/html/images/casino/casino-highlight-idn2.jpg'],
                banner2png: ['/public/html/images/casino/casino-highlight-idn2.png'],
            },
            mobile: {
                bannerAlt1: ['casino-logo-idn2'],
                banner1: ['/public/html/images/cat_img/cat-casino-logo-idn2.png'],
                bannerAlt2: ['casino-mobile-idn2'],
                banner2: ['/public/html/images/cat_img/casino_mobile_idn2.jpg'],
                banner2png: ['/public/html/images/cat_img/casino_mobile_idn2.png'],
            },
        },
        playace: {
            desktop: {
                bannerAlt1: ['casino-bn-ag'],
                banner1: ['/public/html/images/casino/casino-bn-ag.jpg'],
                bannerAlt2: ['casino-highlight-ag'],
                banner2: ['/public/html/images/casino/casino-highlight-ag.jpg'],
                banner2png: ['/public/html/images/casino/casino-highlight-ag.png'],
            },
            mobile: {
                bannerAlt1: ['casino-logo-ag'],
                banner1: ['/public/html/images/cat_img/cat-casino-logo-ag.png'],
                bannerAlt2: ['casino-mobile-ag'],
                banner2: ['/public/html/images/cat_img/casino_mobile_ag.jpg'],
                banner2png: ['/public/html/images/cat_img/casino_mobile_ag.png'],
            },
        },
    },
    CASINO_PROVIDER_IMG: {
        providerImg: [
            {
                id: 1,
                category: 'C',
                provider: 'DG',
                img: '/public/html/images/casino/Asset 11.png',
            },
            {
                id: 2,
                category: 'C',
                provider: 'AG2',
                img: '/public/html/images/casino/Asset 12.png',
            },
            {
                id: 4,
                category: 'C',
                provider: 'EBET',
                img: '/public/html/images/casino/Asset 4.png',
            },
            {
                id: 5,
                category: 'C',
                provider: 'AES2',
                img: '/public/html/images/casino/Asset 5.png',
            },
            {
                id: 6,
                category: 'C',
                provider: 'SA',
                img: '/public/html/images/casino/Asset 6.png',
            },
            {
                id: 7,
                category: 'C',
                provider: 'PT2',
                img: '/public/html/images/casino/Asset 7.png',
            },
            {
                id: 7,
                category: 'C',
                provider: 'PTL',
                img: '/public/html/images/casino/Asset 7.png',
            },
            {
                id: 7.5,
                category: 'C',
                provider: 'PTL4',
                img: '/public/html/images/casino/Asset 7.png',
            },
            {
                id: 8,
                category: 'C',
                provider: 'AB',
                img: '/public/html/images/casino/Asset 8.png',
            },
            {
                id: 9,
                category: 'C',
                provider: 'GP',
                img: '/public/html/images/casino/Asset 9.png',
            },
            {
                id: 10,
                category: 'C',
                provider: 'EVO',
                img: '/public/html/images/casino/Asset 10.png',
            },
        ],

        providerImg02: [
            {
                id: '11',
                category: 'C',
                provider: 'AES2',
                providerName: 'Sexy Baccarat',
                img: '/public/html/images/home_img/home-casino-ae.jpg',
                route: 'sexy-baccarat2',
                isLaunchGameFromLanding: true,
            },
            {
                id: '2',
                category: 'C',
                provider: 'AG2',
                providerName: 'PlayAce',
                img: '/public/html/images/home_img/home-casino-ag.jpg',
                route: 'playace',
                isLaunchGameFromLanding: true,
            },
            {
                id: '9',
                category: 'C',
                provider: 'DG',
                providerName: 'Dream Gaming',
                img: '/public/html/images/home_img/home-casino-dg.jpg',
                route: 'dream-gaming',
                isLaunchGameFromLanding: true,
            },
            {
                id: '1',
                category: 'C',
                provider: 'MGP',
                providerName: 'Microgaming',
                img: '/public/html/images/home_img/home-casino-mg.jpg',
                route: 'microGamingPlus',
                isLaunchGameFromLanding: true,
            },
            {
                id: '2',
                category: 'C',
                provider: 'MGP2',
                providerName: 'MicroGamingPlus2',
                img: '/public/html/images/home_img/home-casino-mg.jpg',
                route: 'microGamingPlus2',
                isLaunchGameFromLanding: true,
            },
            {
                id: '11',
                category: 'C',
                provider: 'MGPL',
                providerName: 'MicroGaming',
                img: '/public/html/images/home_img/home-casino-mg.jpg',
                route: 'Microgaming',
                isLaunchGameFromLanding: true,
            },
            {
                id: '3',
                category: 'C',
                provider: 'EVO',
                providerName: 'Evolution Gaming',
                img: '/public/html/images/home_img/home-casino-evo.jpg',
                route: 'evolution-gaming',
                isLaunchGameFromLanding: true,
            },
            {
                id: '5',
                category: 'C',
                provider: 'GP',
                providerName: 'Gameplay',
                img: '/public/html/images/home_img/home-casino-gp.jpg',
                route: 'gameplay',
                isLaunchGameFromLanding: true,
            },
            {
                id: '6',
                category: 'C',
                provider: 'PT2',
                providerName: 'Playtech',
                img: '/public/html/images/home_img/home-casino-pt.jpg',
                route: 'playtech',
                isLaunchGameFromLanding: true,
            },
            {
                id: '6',
                category: 'C',
                provider: 'PTL',
                providerName: 'Playtech',
                img: '/public/html/images/home_img/home-casino-pt.jpg',
                route: 'playtech',
                isLaunchGameFromLanding: true,
            },
            {
                id: '6',
                category: 'C',
                provider: 'PTL4',
                providerName: 'playtechLive4',
                img: '/public/html/images/home_img/home-casino-pt.jpg',
                route: 'playtech',
                isLaunchGameFromLanding: true,
            },
            {
                id: '7',
                category: 'C',
                provider: 'SA',
                providerName: 'SA Gaming',
                img: '/public/html/images/home_img/home-casino-sa.jpg',
                route: 'sa-gaming',
                isLaunchGameFromLanding: true,
            },
            {
                id: '8',
                category: 'C',
                provider: 'AB',
                providerName: 'Allbet',
                img: '/public/html/images/home_img/home-casino-allbet.jpg',
                route: 'allbet',
                isLaunchGameFromLanding: true,
            },
        ],

        providerImg03: [
            {
                id: '11',
                category: 'C',
                provider: 'AES2',
                providerName: 'Sexy Baccarat',
                img: '/public/html/images/home_img/home-casino-ae.jpg',
                route: 'sexy-baccarat2',
                isLaunchGameFromLanding: true,
            },
            {
                id: '2',
                category: 'C',
                provider: 'AG',
                providerName: 'Asia Gaming',
                img: '/public/html/images/home_img/home-casino-ag.jpg',
                route: 'playace',
                isLaunchGameFromLanding: true,
            },
            {
                id: '9',
                category: 'C',
                provider: 'DG',
                providerName: 'Dream Gaming',
                img: '/public/html/images/home_img/home-casino-dg.jpg',
                route: 'dream-gaming',
                isLaunchGameFromLanding: true,
            },
            {
                id: '1',
                category: 'C',
                provider: 'MGP',
                providerName: 'Microgaming',
                img: '/public/html/images/home_img/home-casino-mg.jpg',
                route: 'microGamingPlus',
                isLaunchGameFromLanding: true,
            },
            {
                id: '2',
                category: 'C',
                provider: 'MGP2',
                providerName: 'MicroGamingPlus2',
                img: '/public/html/images/home_img/home-casino-mg.jpg',
                route: 'microGamingPlus2',
                isLaunchGameFromLanding: true,
            },
            {
                id: '11',
                category: 'C',
                provider: 'MGPL',
                providerName: 'MicroGaming',
                img: '/public/html/images/home_img/home-casino-mg.jpg',
                route: 'microGaming',
                isLaunchGameFromLanding: true,
            },
            {
                id: '3',
                category: 'C',
                provider: 'EVO',
                providerName: 'Evolution Gaming',
                img: '/public/html/images/home_img/home-casino-evo.jpg',
                route: 'evolution-gaming',
                isLaunchGameFromLanding: true,
            },
            {
                id: '5',
                category: 'C',
                provider: 'GP',
                providerName: 'Gameplay',
                img: '/public/html/images/home_img/home-casino-gp.jpg',
                route: 'gameplay',
                isLaunchGameFromLanding: true,
            },
            {
                id: '6',
                category: 'C',
                provider: 'PT2',
                providerName: 'Playtech',
                img: '/public/html/images/home_img/home-casino-pt.jpg',
                route: 'playtech',
                isLaunchGameFromLanding: true,
            },
            {
                id: '6',
                category: 'C',
                provider: 'PTL',
                providerName: 'Playtech',
                img: '/public/html/images/home_img/home-casino-pt.jpg',
                route: 'playtech',
                isLaunchGameFromLanding: true,
            },
            {
                id: '6',
                category: 'C',
                provider: 'PTL4',
                providerName: 'playtechLive4',
                img: '/public/html/images/home_img/home-casino-pt.jpg',
                route: 'playtech',
                isLaunchGameFromLanding: true,
            },
            {
                id: '7',
                category: 'C',
                provider: 'SA',
                providerName: 'SA Gaming',
                img: '/public/html/images/home_img/home-casino-sa.jpg',
                route: 'sa-gaming',
                isLaunchGameFromLanding: true,
            },
            {
                id: '8',
                category: 'C',
                provider: 'AB',
                providerName: 'Allbet',
                img: '/public/html/images/home_img/home-casino-allbet.jpg',
                route: 'allbet',
                isLaunchGameFromLanding: true,
            },
            {
                id: '10',
                category: 'C',
                provider: 'EBET',
                providerName: 'Ebet',
                img: '/public/html/images/home_img/home-casino-ebet.jpg',
                route: 'ebet',
                isLaunchGameFromLanding: true,
            },
        ],
    },
    LOTTERY_BANNER: {
        qqkeno: {
            banner1: '/public/html/images/lottery/lottery-bn-qqkeno.jpg',
            bannerAlt1: 'qqkeno-bn',
        },
        spl: {
            banner1: '/public/html/images/lottery/lottery-bn-spl.jpg',
            bannerAlt1: 'spl-bn',
        },
        qqkenothai: {
            banner1: '/public/html/images/lottery/lottery-bn-qqthai.jpg',
            bannerAlt1: 'qqkeno-thai-bn',
        },
        gameplay: {
            banner1: '/public/html/images/lottery/lottery-bn-gp.jpg',
            bannerAlt1: 'gameplay-lottery',
        },
        funkygames: {
            banner1: '/public/html/images/lottery/lottery-bn-fg.jpg',
            bannerAlt1: 'funkygames',
        },
        t7: {
            banner1: '/public/html/images/lottery/lottery-bn-t7.jpg',
            bannerAlt1: 't7',
        },
        wwl: {
            banner1: '/public/html/images/lottery/lottery-bn-wwl.jpg',
            bannerAlt1: 'wwl',
        },
        tcg: {
            banner1: '/public/html/images/lottery/lottery-bn-tcg.jpg',
            bannerAlt1: 'tcg',
        },
        ed: {
            banner1: '/public/html/images/lottery/lottery-bn-ed.jpg',
            bannerAlt1: 'ed',
        },
        edvn: {
            banner1: '/public/html/images/lottery/lottery-bn-edvn.jpg',
            bannerAlt1: 'edvn-bn',
        },
    },
    SPORT_BANNER: {
        m8: {
            title: 'Sports M9',
        },
        cmd: {
            title: 'Sports CMD',
            banner: ['/public/html/images/sports/cmd_banner.jpg'],
        },
        bti: {
            title: 'Sports BTI',
            banner: ['/public/html/images/sports/bti_banner.jpg'],
        },
        bti2: {
            title: 'Sports BTI',
            banner: ['/public/html/images/sports/bti_banner.jpg'],
        },
        br: {
            bannerAlt: ['virtual-bn'],
            banner: ['/public/html/images/sports/virtual-bn.jpg'],
            galleryBanner: [
                {
                    id: '1',
                    banner: '/public/html/images/sports/virtual-sub-football.png',
                    setBanner: 'S-BR-Gallery-football.png',
                    bannerAlt: 'virtual-sub-football',
                    type: 'football',
                    gameCode: 'VFL',
                },
                {
                    id: '2',
                    banner: '/public/html/images/sports/virtual-sub-basketball.png',
                    setBanner: 'S-BR-Gallery-basketball.png',
                    bannerAlt: 'virtual-sub-basketball',
                    type: 'basketball',
                    gameCode: 'VBL',
                },
                {
                    id: '3',
                    banner: '/public/html/images/sports/virtual-sub-tennis.png',
                    setBanner: 'S-BR-Gallery-tennis.png',
                    bannerAlt: 'virtual-sub-tennis',
                    type: 'tennis',
                    gameCode: 'VTO',
                },
                {
                    id: '4',
                    banner: '/public/html/images/sports/virtual-sub-horse.png',
                    setBanner: 'S-BR-Gallery-horse.png',
                    bannerAlt: 'virtual-sub-horse',
                    type: 'horses',
                    gameCode: 'VHC',
                },
                {
                    id: '5',
                    banner: '/public/html/images/sports/virtual-sub-greyhounds.png',
                    setBanner: 'S-BR-Gallery-greyhounds.png',
                    bannerAlt: 'virtual-sub-greyhounds',
                    type: 'greyhounds',
                    gameCode: 'VDR',
                },
            ],
        },
        ufa: {
            bannerAlt: ['ufabet-bn'],
            banner: ['/public/html/images/sports/ufabet-bn.jpg'],
        },
        sport: {
            banner: ['/public/html/images/sports/sport_banner.jpg'],
        },
        sbo: {
            banner: ['/public/html/images/sports/sbobet-bn.jpg'],
        },
        sbo2: {
            banner: ['/public/html/images/sports/sbobet-bn.jpg'],
        },
        bbs: {
            banner: ['/public/html/images/sports/bbs_banner.jpg'],
        },
    },
    ESPORT_BANNER: {
        mainBanner: ['/public/html/images/sports/main-esport.png'],
        mainBanner2: ['/public/html/images/sports/main-esport.jpg'],
        ime: {
            providerBanner: ['/public/html/images/sports/e-sports-ime.jpg'],
            banner2: ['/public/html/images/sports/sports-bg.jpg'],
        },
        tf: {
            providerBanner: ['/public/html/images/sports/e-sports-tf.jpg'],
            banner2: ['/public/html/images/sports/sports-bg.jpg'],
        },
        btr: {
            providerBanner: ['/public/html/images/sports/e-sports-btr.jpg'],
            banner2: ['/public/html/images/sports/sports-bg.jpg'],
        },
        esportbg: ['/public/html/images/sports/esport_bg.png'],
        leagueBanner: ['/public/html/images/sports/esport-1.png'],
        dataBanner: ['/public/html/images/sports/esport-2.jpg'],
        counterStrikBanner: ['/public/html/images/sports/esport-3.png'],
        andMoreBanner: ['/public/html/images/sports/esport-4.jpg'],
        bottom: ['/public/html/images/sports/bottom-esport.jpg'],
    },
    GAME_BANNER: {
        km: {
            banner: ['/public/html/images/3dgames/3d-games-bn-km.jpg'],
        },
        km2: {
            banner: ['/public/html/images/3dgames/3d-games-bn-km.jpg'],
        },
        gp: {
            banner: ['/public/html/images/3dgames/3d-games-bn-gp.jpg'],
        },
        v8: {
            banner: ['/public/html/images/3dgames/3d-games-bn-v8.jpg'],
        },
        mt: {
            banner: ['/public/html/images/3dgames/3d-games-bn-mt.jpg'],
        },
        kms: {
            banner: ['/public/html/images/3dgames/3d-games-bn-kms.jpg'],
        },
    },
    SIDEBAR_IMG: {
        contactBanner: ['/public/html/images/home_img/contact_dd_speed.png'],
        hotgamesIcon: ['/public/html/images/home_img/hg_dd_icon_hot.gif'],
        hotgamesGif: ['/public/html/images/home_img/hg_dd_icon_hot2.gif'],
        hotBanner: ['/public/html/images/home_img/hg_dd_bn_fog.png'],
        hotgameNewBorder: ['/public/html/images/home_img/hg_dd_band_new.png'],
        hotgameHotBorder: ['/public/html/images/home_img/hg_dd_band_hot.png'],
        hotgameRecBorder: ['/public/html/images/home_img/hg_dd_band_reco.png'],
        hotgamesNew: ['/public/html/images/home_img/hg_dd_icon_new.gif'],
        hotgamesNew2: ['/public/html/images/home_img/hg_dd_icon_new.png'],
        account: '/public/html/images/sidebar/sb-account.png',
        bank: '/public/html/images/sidebar/sb-bank.png',
        contact: '/public/html/images/sidebar/sb-contact.png',
        deposit: '/public/html/images/sidebar/sb-deposit.png',
        desktop: '/public/html/images/sidebar/sb-desktop.png',
        home: '/public/html/images/sidebar/sb-home.png',
        logout: '/public/html/images/sidebar/sb-logout.png',
        promotion: '/public/html/images/sidebar/sb-promotion.png',
        referral: '/public/html/images/sidebar/sb-referral.png',
        affiliate: '/public/html/images/sidebar/sb-referral.png',
        transfer: '/public/html/images/sidebar/sb-transfer.png',
        vip: '/public/html/images/sidebar/sb-vip.png',
        withdraw: '/public/html/images/sidebar/sb-withdraw.png',
    },
    MEMBER_SERVICE: {
        contactBanner: {
            zh: ['/public/html/images/home_img/contact_dd_speed_cn.png'],
            en: ['/public/html/images/home_img/contact_dd_speed.png'],
            ms: ['/public/html/images/home_img/contact_dd_speed_ms.png'],
            th: ['/public/html/images/home_img/contact_dd_speed_th.png'],
            vi: ['/public/html/images/home_img/contact_dd_speed_vi.png'],
            id: ['/public/html/images/home_img/contact_dd_speed.png'],
            km: ['/public/html/images/home_img/contact_dd_speed.png'],
            bn: ['/public/html/images/home_img/contact_dd_speed.png'],
            en_vn: ['/public/html/images/home_img/contact_dd_speed_en-vn.png'],
            tl: ['/public/html/images/home_img/contact_dd_speed_tl.png'],
        },
    },
    AFF_IMG: {
        mainBanner: ['/public/html/images/home_img/aff-1.png'],
        banner2: ['/public/html/images/home_img/aff-2.png'],
        banner3: ['/public/html/images/home_img/aff-3.png'],
        banner4: ['/public/html/images/home_img/aff-4.png'],
        banner5: ['/public/html/images/home_img/aff-5.png'],
    },
    SLIDER_BUTTON: {
        nextButton: ['/public/html/images/home_img/button_right.png'],
        prevButton: ['/public/html/images/home_img/button_left.png'],
    },
    JACKPORT_IMG: {
        jackpotBg: ['/public/html/images/home_img/jackpot-base.png'],
        jackpotGif: ['/public/html/images/home_img/progressive_jackpot.gif'],
        jackpotJpg: ['/public/html/images/home_img/progressive_jackpot.jpg'],
    },
    guide_step_one_img_currency: '/public/html/images/home_img/stepping_tool_white_[currency].jpg',
    GUIDE_STEP: {
        step1: ['/public/html/images/home_img/step-1-[currency].png'],
        step2: ['/public/html/images/home_img/step-2-[currency].png'],
        step3: ['/public/html/images/home_img/step-3-[currency].png'],
        step4: ['/public/html/images/home_img/step-4-[currency].png'],
        step5: ['/public/html/images/home_img/step-5-[currency].png'],
    },
    guide_step_03: {
        step_1: ['/public/html/images/home_img/step-1.png'],
        step_2: ['/public/html/images/home_img/step-2.png'],
        step_3: ['/public/html/images/home_img/step-3.png'],
        step_1_icon: ['/public/html/images/home_img/step-1-icon.png'],
        step_2_icon: ['/public/html/images/home_img/step-2-icon.png'],
        step_3_icon: ['/public/html/images/home_img/step-3-icon.png'],
    },
    guide_step__ss2_1: {
        step_1: ['/public/html/images/home_img/step-icon-register.png'],
        step_2: ['/public/html/images/home_img/step-icon-deposit.png'],
        step_3: ['/public/html/images/home_img/step-icon-play.png'],
    },
    CONTACT_ICON: {
        livechat: ['/public/html/images/home_img/livechat.png'],
        gmail: ['/public/html/images/home_img/gmail.png'],
        wechat: ['/public/html/images/home_img/wc.png'],
        phone: ['/public/html/images/home_img/phone.png'],
        wahtapp: ['/public/html/images/home_img/phone02.png'],
        email: ['/public/html/images/home_img/mail.png'],
        telegram: ['/public/html/images/home_img/telegram.png'],
    },
    HOME_INFOR: [
        {
            id: '1',
            name: 'Sports',
            path: '/public/html/images/home_img/home-sports-icon.png',
            pathOv: '/public/html/images/home_img/home-sports-icon-ov.png',
            route: '/cmd368',
            desc: 'home:home.content.sports',
            href: '/sports-landing',
        },
        {
            id: '2',
            name: 'Casino',
            path: '/public/html/images/home_img/home-casino-icon.png',
            pathOv: '/public/html/images/home_img/home-casino-icon-ov.png',
            route: '/casino/sexy-baccarat',
            desc: 'home:home.content.casino',
            href: '/casino-landing',
        },
        {
            id: '3',
            name: 'Slots',
            path: '/public/html/images/home_img/home-slots-icon.png',
            pathOv: '/public/html/images/home_img/home-slots-icon-ov.png',
            route: '/slots/spadeGaming',
            desc: 'home:home.content.slots',
            href: '/slots/spadeGaming',
        },
        {
            id: '4',
            name: 'Fishing',
            path: '/public/html/images/home_img/home-fishing-icon.png',
            pathOv: '/public/html/images/home_img/home-fishing-icon-ov.png',
            route: '/sg-fishingwar',
            desc: 'home:home.content.fishing',
            href: '/fish/spadeGaming',
        },
        {
            id: '5',
            name: 'Lottery',
            path: '/public/html/images/home_img/home-lottery-icon.png',
            pathOv: '/public/html/images/home_img/home-lottery-icon-ov.png',
            route: '/qqkeno-thai',
            desc: 'home:home.content.lottery',
            href: '/lottery',
        },
    ],
    HOME_CONTENT: {
        slot: ['/public/html/images/home_img/home_slot.jpg'],
        casino: ['/public/html/images/home_img/home_casino.jpg'],
        fishing: ['/public/html/images/home_img/home_fishing.jpg'],
        sports: ['/public/html/images/home_img/home_sports.jpg'],
        contact: ['/public/html/images/home_img/home_contact.jpg'],
        contactByLang: {
            en: ['/public/html/images/home_img/home_contact_en.jpg'],
            'zh-CN': ['/public/html/images/home_img/home_contact_cn.jpg'],
            ms: ['/public/html/images/home_img/home_contact_my.jpg'],
            th: ['/public/html/images/home_img/home_contact_th.jpg'],
        },
        accordinSilder01: ['/public/html/images/home_img/accordinSilder01.png'],
        accordinSilderHover01: ['/public/html/images/home_img/accordinSilder01-on.png'],
        accordinSilder02: ['/public/html/images/home_img/accordinSilder02.png'],
        accordinSilderHover02: ['/public/html/images/home_img/accordinSilder02-on.png'],
        accordinSilder03: ['/public/html/images/home_img/accordinSilder03.png'],
        accordinSilderHover03: ['/public/html/images/home_img/accordinSilder03-on.png'],
        accordinSilder04: ['/public/html/images/home_img/accordinSilder04.png'],
        accordinSilderHover04: ['/public/html/images/home_img/accordinSilder04-on.png'],
        depositBtn: '/public/html/images/home_img/home-btn-deposit-{countryLang}.png',
        withdrawBtn: '/public/html/images/home_img/home-btn-withdraw-{countryLang}.png',
        affiliateBtn: '/public/html/images/home_img/home-btn-affiliate-{countryLang}.png',
        theHottestGameTitleImg: ['/public/html/images/home_img/home_title_theHottestGame.png'],
        jackportTitleImg: ['/public/html/images/home_img/home_title_jackport.png'],
        hotmatch: ['/public/html/images/home_img/hotmatch-icon.png'],
        hotgame: ['/public/html/images/home_img/hotgame-icon.png'],
        hoticon: ['/public/html/images/home_img/hot-icon.png'],
        livecasino: ['/public/html/images/home_img/live-casino-icon.png'],
        fishingGame: ['/public/html/images/home_img/fishing-icon.png'],
    },
    MOBILE_HOME_CONTENT: {
        casinoBtn: '/public/html/images/home_img/home_casino_on-{countryLang}.png',
        sportsBtn: '/public/html/images/home_img/home_sport_on-{countryLang}.png',
        esportsBtn: '/public/html/images/home_img/home_esport_on-{countryLang}.png',
        slotBtn: '/public/html/images/home_img/home_slot_on-{countryLang}.png',
        lotteryBtn: '/public/html/images/home_img/home_lottery_on-{countryLang}.png',
        gamesBtn: '/public/html/images/home_img/home_3dgame_on-{countryLang}.png',
        gameTabArrowBtn: '/public/html/images/home_img/game-tab-arrow.png',
        sportBettingBtn: '/public/html/images/home_img/home_sport_betting.jpg',
        casinoOnlineBtn: '/public/html/images/home_img/home_casino_online.jpg',
        slotsOnlineBtn: '/public/html/images/home_img/home_slots_online.jpg',
        fishingShootingBtn: '/public/html/images/home_img/home_fishing_shooting.jpg',
    },
    ICON_IMAGES_GOLD: {
        memberServices: ['/public/html/images/home_img/home_icon_memberservice.png'],
        hotMatches: ['/public/html/images/home_img/home_icon_hotmatch.png'],
        liveCasino: ['/public/html/images/home_img/home_icon_livecasino.png'],
        hotMatches2: ['/public/html/images/home_img/home_icon_hotmatch2.png'],
        liveCasino2: ['/public/html/images/home_img/home_icon_livecasino2.png'],
        hotGame: ['/public/html/images/home_img/home_icon_hotgames.png'],
    },
    MOBILEFOOTER: {
        homeAmbassador_eng: ['/public/html/images/footer/Brand-Ambassador-Section.png'],
        homeAmbassador_zh: ['/public/html/images/footer/Brand-Ambassador-Section-zh.png'],
        homeAmbassador_bm: ['/public/html/images/footer/Brand-Ambassador-Section-bm.png'],
        homeAmbassador_th: ['/public/html/images/footer/Brand-Ambassador-Section-th.png'],
        homeAmbassador_lang: ['/public/html/images/footer/Brand-Ambassador-Section-[lang].png'],
    },
    FOOTER: {
        ambbtmBanner_eng: ['/public/html/images/footer/Brand-Ambassador-eng.png'],
        ambbtmBanner_th: ['/public/html/images/footer/Brand-Ambassador-th.png'],
        ambbtmBanner_zh: ['/public/html/images/footer/Brand-Ambassador-zh.png'],
        ambbtmBanner_bm: ['/public/html/images/footer/Brand-Ambassador-bm.png'],
        ambmobileBanner: ['/public/html/images/footer/Brand-Ambassador-Section.png'],
        footerLandingSlot: ['/public/html/images/footer/footer-landing-banner-slot.jpg'],
        footerLandingCasino: ['/public/html/images/footer/footer-landing-banner-casino.jpg'],
    },
    HOME_SIDEBAR_BANNER: {
        videoBanner: ['/public/html/images/home_img/videoBanner.png'],
    },
    MOBILE_ADD_TO_HOME: {
        android: {
            img: '/public/html/images/icon/andriod-a2hs.png',
        },
        ios: {
            img: '/public/html/images/icon/ios-a2hs.png',
        },
    },
    SLOT_LANDING_BANNER: {
        banner: {
            zh: ['/public/html/images/slot_img/slots-bn-cn.jpg'],
            en: ['/public/html/images/slot_img/slots-bn-en.jpg'],
            ms: ['/public/html/images/slot_img/slots-bn-ms.jpg'],
            th: ['/public/html/images/slot_img/slots-bn-th.jpg'],
        },
        defaultBanner: '/public/html/images/slot_img/slots-bn.jpg',
    },
    CASINO_LANDING_BANNER: {
        banner: {
            zh: ['/public/html/images/casino/casino-bn-cn.jpg'],
            en: ['/public/html/images/casino/casino-bn.jpg'],
            ms: ['/public/html/images/casino/casino-bn-ms.jpg'],
            th: ['/public/html/images/casino/casino-bn-th.jpg'],
        },
        defaultBanner: '/public/html/images/casino/casino-bn.jpg',
        bannerWithLang: '/public/html/images/casino/casino-bn-{{lang}}.jpg',
    },
    ESPORT_LANDING_BANNER: {
        defaultBanner: '/public/html/images/esports/esports-bn.jpg',
        zh: '/public/html/images/esports/esports-bn-cn.jpg',
        en: '/public/html/images/esports/esports-bn-en.jpg',
        my: '/public/html/images/esports/esports-bn-my.jpg',
        ms: '/public/html/images/esports/esports-bn-ms.jpg',
    },
    COCKFIGHT_LANDING_BANNER: {
        defaultBanner: '/public/html/images/drawer_img/cockfight-bn.jpg',
        zh: '/public/html/images/drawer_img/cockfight-bn-cn.jpg',
        en: '/public/html/images/drawer_img/cockfight-bn-en.jpg',
        my: '/public/html/images/drawer_img/cockfight-bn-my.jpg',
        ms: '/public/html/images/drawer_img/cockfight-bn-ms.jpg',
        id: '/public/html/images/drawer_img/cockfight-bn-id.jpg',
        vn: '/public/html/images/drawer_img/cockfight-bn-vn.jpg',
        kh: '/public/html/images/drawer_img/cockfight-bn-kh.jpg',
    },
    EXCHANGE_LANDING_BANNER: {
        defaultBanner: '/public/html/images/drawer_img/exchange-bn.png',
        zh: '/public/html/images/drawer_img/exchange-bn-cn.png',
        en: '/public/html/images/drawer_img/exchange-bn-en.png',
        my: '/public/html/images/drawer_img/exchange-bn-my.png',
        ms: '/public/html/images/drawer_img/exchange-bn-ms.png',
        id: '/public/html/images/drawer_img/exchange-bn-id.png',
        vn: '/public/html/images/drawer_img/exchange-bn-vn.png',
        kh: '/public/html/images/drawer_img/exchange-bn-kh.png',
    },
    LIVEGAMES_LANDING_BANNER: {
        defaultBanner: '/public/html/images/drawer_img/livegames-bn.png',
        zh: '/public/html/images/drawer_img/livegames-bn-cn.png',
        en: '/public/html/images/drawer_img/livegames-bn-en.png',
        my: '/public/html/images/drawer_img/livegames-bn-my.png',
        ms: '/public/html/images/drawer_img/livegames-bn-ms.png',
        id: '/public/html/images/drawer_img/livegames-bn-id.png',
        vn: '/public/html/images/drawer_img/livegames-bn-vn.png',
        kh: '/public/html/images/drawer_img/livegames-bn-kh.png',
    },
    TVGAMES_LANDING_BANNER: {
        defaultBanner: '/public/html/images/tvgames/tvgames-bn.jpg',
    },
    FISHING_LANDING_BANNER: {
        banner: {
            zh: ['/public/html/images/fishing/fishing-bn-cn.jpg'],
            en: ['/public/html/images/fishing/fishing-bn-en.jpg'],
            ms: ['/public/html/images/fishing/fishing-bn-ms.jpg'],
            th: ['/public/html/images/fishing/fishing-bn-th.jpg'],
            id: ['/public/html/images/fishing/fishing-bn-id.jpg'],
        },
        gggaming: {
            zh: ['/public/html/images/fishing/fishing-gg-cn.jpg'],
            en: ['/public/html/images/fishing/fishing-gg-en.jpg'],
            ms: ['/public/html/images/fishing/fishing-gg-en.jpg'],
            th: ['/public/html/images/fishing/fishing-gg-en.jpg'],
        },
        sgfishing: {
            zh: ['/public/html/images/fishing/fishing-sg-cn.jpg'],
            en: ['/public/html/images/fishing/fishing-sg-en.jpg'],
            ms: ['/public/html/images/fishing/fishing-sg-en.jpg'],
            th: ['/public/html/images/fishing/fishing-sg-en.jpg'],
        },
        sgfishingwar: {
            zh: ['/public/html/images/fishing/fishing-sgfw-cn.jpg'],
            en: ['/public/html/images/fishing/fishing-sgfw-en.jpg'],
            ms: ['/public/html/images/fishing/fishing-sgfw-en.jpg'],
            th: ['/public/html/images/fishing/fishing-sgfw-en.jpg'],
        },
        spadegamingfishingwar: {
            zh: ['/public/html/images/fishing/fishing-sgfw-cn.jpg'],
            en: ['/public/html/images/fishing/fishing-sgfw-en.jpg'],
            ms: ['/public/html/images/fishing/fishing-sgfw-en.jpg'],
            th: ['/public/html/images/fishing/fishing-sgfw-en.jpg'],
        },
        SaBannerCN: ['/public/html/images/fishing/fishing-sa-cn.jpg'],
        SaBannerEN: ['/public/html/images/fishing/fishing-sa-en.jpg'],
        PtBannerCN: ['/public/html/images/fishing/fishing-pt-cn.jpg'],
        PtBannerEN: ['/public/html/images/fishing/fishing-pt-en.jpg'],
        defaultBanner: '/public/html/images/fishing/fishing-bn.jpg',
    },
    GAME_LANDING_BANNER: {
        banner: ['/public/html/images/3dgames/3Dgames-bn-en.jpg'],
        defaultBanner: '/public/html/images/3dgames/3Dgames-bn.jpg',
        bannerWithLang: '/public/html/images/casino/3Dgames-bn-{{lang}}.jpg',
    },
    SPORT_LANDING_BANNER: {
        defaultBanner: '/public/html/images/sports/sports-bn.jpg',
        sportsIndexBg: '/public/html/images/sports/sports-index-bn.jpeg',
        zh: '/public/html/images/sports/sports-bn-cn.jpg',
        en: '/public/html/images/sports/sports-bn-en.jpg',
        my: '/public/html/images/sports/sports-bn-my.jpg',
        ms: '/public/html/images/sports/sports-bn-ms.jpg',
    },
    RACING_LANDING_BANNER: {
        defaultBanner: '/public/html/images/racing/racing-bn.jpg',
    },
    LOTTERY_LANDING_BANNER: {
        banner: ['/public/html/images/lottery/lottery-bn.jpg'],
        defaultBanner: '/public/html/images/lottery/lottery-bn.jpg',
        zh: '/public/html/images/lottery/lottery-bn-cn.jpg',
        en: '/public/html/images/lottery/lottery-bn-en.jpg',
        my: '/public/html/images/lottery/lottery-bn-my.jpg',
        ms: '/public/html/images/lottery/lottery-bn-ms.jpg',
        th: '/public/html/images/lottery/lottery-bn-th.jpg',
    },
    FASTGAMES_LANDING_BANNER: {
        banner: ['/public/html/images/fastgames/fastgames-bn.jpg'],
        defaultBanner: '/public/html/images/fastgames/fastgames-bn.jpg',
        zh: '/public/html/images/fastgames/fastgames-bn-cn.jpg',
        en: '/public/html/images/fastgames/fastgames-bn-en.jpg',
        my: '/public/html/images/fastgames/fastgames-bn-my.jpg',
        ms: '/public/html/images/fastgames/fastgames-bn-ms.jpg',
        th: '/public/html/images/fastgames/fastgames-bn-th.jpg',
    },
    POKER_LANDING_BANNER: {
        banner: ['/public/html/images/poker/poker-bn.jpg'],
        defaultBanner: ['/public/html/images/poker/poker-bn.jpg'],
        zh: '/public/html/images/poker/poker-bn-cn.jpg',
        en: '/public/html/images/poker/poker-bn-en.jpg',
        my: '/public/html/images/poker/poker-bn-my.jpg',
        ms: '/public/html/images/poker/poker-bn-ms.jpg',
    },
    FOURD_LANDING_BANNER: {
        defaultBanner: ['/public/html/images/fourD/fourD-bn.jpg'],
    },
    SERVICE_ICON: {
        serviceadvTitle: ['/public/html/images/home_img/home_icon_serviceadv.png'],
        infoTitle: ['/public/html/images/home_img/home_icon_infocenter.png'],
        memberservTitle: ['/public/html/images/home_img/home_icon_memberservice.png'],
        hotCasinoGame: ['/public/html/images/home_img/home_icon_livecasino.png'],
        featuredOn: ['/public/html/images/home_img/home_icon_featuredOn.png'],
    },
    REG_BANNER: {
        banner: {
            zh: ['/public/html/images/home_img/reg-banner-cn.jpg'],
            en: ['/public/html/images/home_img/reg-banner-en.jpg'],
            ms: ['/public/html/images/home_img/reg-banner-en.jpg'],
            th: ['/public/html/images/home_img/reg-banner-th.jpg'],
        },
        banner_countryLanguageKey: {
            ZH_MY: ['/public/html/images/home_img/reg-banner-cn.jpg'],
            MS_MY: ['/public/html/images/home_img/reg-banner-en.jpg'],
            EN_MY: ['/public/html/images/home_img/reg-banner-en.jpg'],
            EN_SG: ['/public/html/images/home_img/reg-banner-en.jpg'],
            ZH_SG: ['/public/html/images/home_img/reg-banner-cn.jpg'],
            EN_TH: ['/public/html/images/home_img/reg-banner-en.jpg'],
            TH_TH: ['/public/html/images/home_img/reg-banner-th.jpg'],
            EN_KH: ['/public/html/images/home_img/reg-banner-en.jpg'],
            EN_ID: ['/public/html/images/home_img/reg-banner-id.jpg'],
            ID_ID: ['/public/html/images/home_img/reg-banner-id.jpg'],
        },
    },
    MOBILE_REG_BANNER: {
        banner: {
            zh: ['/public/html/images/home_img/m-reg-banner-cn.jpg'],
            en: ['/public/html/images/home_img/m-reg-banner-en.jpg'],
            ms: ['/public/html/images/home_img/m-reg-banner-en.jpg'],
            th: ['/public/html/images/home_img/m-reg-banner-th.jpg'],
        },

        banner_countryLanguageKey: {
            ZH_MY: ['/public/html/images/home_img/reg-banner-cn.jpg'],
            MS_MY: ['/public/html/images/home_img/reg-banner-en.jpg'],
            EN_MY: ['/public/html/images/home_img/reg-banner-en.jpg'],
            EN_SG: ['/public/html/images/home_img/reg-banner-en.jpg'],
            ZH_SG: ['/public/html/images/home_img/reg-banner-cn.jpg'],
            EN_TH: ['/public/html/images/home_img/reg-banner-en.jpg'],
            TH_TH: ['/public/html/images/home_img/reg-banner-th.jpg'],
            EN_KH: ['/public/html/images/home_img/reg-banner-en.jpg'],
            EN_ID: ['/public/html/images/home_img/mobile-reg-banner-id.jpg'],
            ID_ID: ['/public/html/images/home_img/mobile-reg-banner-id.jpg'],
        },
    },
    MOBILE_BOTTOM_NAV_BEFORE_LOGIN: [
        {
            id: 1,
            text: 'Home',
            svgname: 'home',
            path: '/public/html/images/home_img/ftrmenu-home.png',
            route: '/',
            translate: 'global:global.menu.home',
        },
        {
            id: 2,
            text: 'Join',
            svgname: 'funds',
            path: '/public/html/images/home_img/ftrmenu-join.png',
            route: '/register',
            translate: 'home:home.mobile.register',
        },
        {
            id: 3,
            text: 'Login',
            svgname: 'Login',
            path: '/public/html/images/home_img/ftrmenu-login.png',
            route: '/login',
            translate: 'home:home.mobile.login',
        },
        {
            id: 4,
            text: 'Promotion',
            svgname: 'promotion',
            path: '/public/html/images/home_img/ftrmenu-promo.png',
            route: '/promotion',
            translate: 'home:home.mobile.promotionShort',
        },
        {
            id: 5,
            text: 'Live Chat',
            path: '/public/html/images/home_img/ftrmenu-chat.png',
            svgname: 'livechat',
            type: 'button',
            route: '/',
            translate: 'global:footer.livechat',
        },
    ],
    MOBILE_BOTTOM_NAV_AFFTER_LOGIN: [
        {
            id: 1,
            text: 'Home',
            svgname: 'home',
            path: '/public/html/images/home_img/ftrmenu-home.png',
            route: '/',
            translate: 'global:global.menu.home',
        },
        {
            id: 2,
            text: 'Deposit',
            svgname: 'deposit',
            path: '/public/html/images/home_img/ftrmenu-deposit.png',
            route: '/myaccount/deposit',
            translate: 'global:global.menu.account.deposit',
        },
        {
            id: 3,
            text: 'Promotion',
            svgname: 'promotion',
            path: '/public/html/images/home_img/ftrmenu-promo.png',
            route: '/promotion',
            translate: 'home:home.mobile.promotionShort',
        },
        {
            id: 4,
            text: 'Withdraw',
            svgname: 'withdraw',
            path: '/public/html/images/home_img/ftrmenu-withdraw.png',
            route: '/myaccount/withdraw',
            translate: 'global:global.menu.account.withdraw',
        },
        {
            id: 5,
            text: 'Live Chat',
            path: '/public/html/images/home_img/ftrmenu-chat.png',
            svgname: 'livechat',
            route: '/',
            translate: 'global:footer.livechat',
        },
    ],
    MOBILE_LOGIN: {
        user: ['/public/html/images/icon/register-user.png'],
        password: ['/public/html/images/icon/register-password.png'],
        LOGIN_BTN: ['/public/html/images/icon/btn-login-{countryLang}.png'],
        REGISTER_BTN: ['/public/html/images/icon/btn-register-{countryLang}.png'],
    },
    MOBILE_REGISTER: {
        HEADER: ['/public/html/images/icon/register-header-{countryLang}.png'],
        PROGRESS_STEP_1: ['/public/html/images/icon/register-progress-bar-1.png'],
        PROGRESS_STEP_2: ['/public/html/images/icon/register-progress-bar-2.png'],
        PROGRESS_STEP_3: ['/public/html/images/icon/register-progress-bar-3.png'],
        BACK_BTN: ['/public/html/images/icon/register-back-btn.png'],
        NEXT_BTN: ['/public/html/images/icon/register-next-{countryLang}.png'],
        SUBMIT_BTN: ['/public/html/images/icon/register-submit-btn-{countryLang}.png'],
        BACK_STEP_BTN: ['/public/html/images/icon/register-back-step-btn-{countryLang}.png'],
    },
    HOME_ICON_IMG: {
        HighlightVideoImg: ['/public/html/images/home_img/home_icon_highlightvid.png'],
        JackPortIcon: ['/public/html/images/home_img/jackpotIcon.png'],
        sportEuroImg: ['/public/html/images/home_img/home-icon-euro.png'],
        sportEuroSVG: ['/public/html/images/home_img/home-icon-euro.svg'],
    },
    MINI_JACKPORT_IMG: {
        IMG_NEXTPIN: ['/public/html/images/home_img/home_jackpot_nextspin.png'],
        IMG_SG: ['/public/html/images/home_img/home_jackpot_sg.png'],
        IMG_PT: ['/public/html/images/home_img/home_jackpot_pt.png'],
        IMG_GP: ['/public/html/images/home_img/home_jackpot_gp.png'],
    },
    MOBILE_SIDEBANNER: {
        lineBanner: ['/public/html/images/home_img/line-sidebar.png'],
        funsBanner: ['/public/html/images/home_img/fund-sidebar.jpg'],
    },
    PROVIDER_BANNER: {
        sportBg: ['/public/html/images/home_img/home_provider_bg_sport.png'],
        sportFront: ['/public/html/images/home_img/home_provider_item_sport.png'],
        sportMiddle: ['/public/html/images/home_img/slot_middle.png'],
        esportBg: ['/public/html/images/home_img/home_provider_bg_esport.png'],
        esporFront: ['/public/html/images/home_img/home_provider_item_esport.png'],
        esporMiddle: ['/public/html/images/home_img/esport_middle.png'],
        lcBg: ['/public/html/images/home_img/home_provider_bg_casino.png'],
        lcFront: ['/public/html/images/home_img/home_provider_item_casino.png'],
        lcMiddle: ['/public/html/images/home_img/lc_middle.png'],
        slotBg: ['/public/html/images/home_img/home_provider_bg_slot.png'],
        slotFront: ['/public/html/images/home_img/home_provider_item_slot.png'],
        slotMiddle: ['/public/html/images/home_img/slot_middle.png'],
        pokerBg: ['/public/html/images/home_img/home_provider_bg_poker.png'],
        pokerFront: ['/public/html/images/home_img/home_provider_item_poker.png'],
        pokerMiddle: ['/public/html/images/home_img/poker_middle.png'],
        fishingBg: ['/public/html/images/home_img/home_provider_bg_fishing.png'],
        fishingFront: ['/public/html/images/home_img/home_provider_item_fishing.png'],
        fishingMiddle: ['/public/html/images/home_img/fishing_middle.png'],
        lotteryBg: ['/public/html/images/home_img/home_provider_bg_lottery.png'],
        lotteryFront: ['/public/html/images/home_img/home_provider_item_lottery.png'],
        lotteryMiddle: ['/public/html/images/home_img/lottery_middle.png'],
    },
    DOWNLOAD_PAGE: {
        androidTAB: '/public/html/images/download_img/download-android-tab.png',
        iosTAB: '/public/html/images/download_img/download-ios-tab.png',
    },
    MOBILE_BOTTOM_NAVBAR: {
        HOME: '/public/html/images/home_img/bottom-navbar-home-{countryLang}.png',
        FUNDS: '/public/html/images/home_img/bottom-navbar-funds-{countryLang}.png',
        MY_ACCOUNT: '/public/html/images/home_img/bottom-navbar-myaccount-{countryLang}.png',
        PROMOTION: '/public/html/images/home_img/bottom-navbar-promotion-{countryLang}.png',
        LIVE_CHAT: '/public/html/images/home_img/bottom-navbar-livechat-{countryLang}.png',
        REFERRAL: '/public/html/images/home_img/bottom-navbar-referral-{countryLang}.png',
        LOGOUT: '/public/html/images/home_img/bottom-navbar-logout-{countryLang}.png',
    },
    MOBILE_bottomNav5: {
        HOME: '/public/html/images/home_img/submenu-home-button.png',
        FUNDS: '/public/html/images/home_img/submenu-fund-button.png',
        MY_ACCOUNT: '/public/html/images/home_img/submenu-myaccount-button.png',
        PROMOTION: '/public/html/images/home_img/submenu-promo-button.png',
        LIVE_CHAT: '/public/html/images/home_img/submenu-livechat-button.png',
        LOGOUT: '/public/html/images/home_img/submenu-logout-button.png',
    },
    MOBILE_ACCOUNT: {
        profile_png: '/public/html/images/account/profile.png',
        restore: '/public/html/images/account/icon-restore.png',
        withdrawRestore: '/public/html/images/account/icon-withdraw-restore.png',
        defaultGroup: '/public/html/images/account/default-group.png',
        message: '/public/html/images/account/btn-message-{countryLang}.png',
        bank: '/public/html/images/account/btn-bank-{countryLang}.png',
        chgGamePassword: '/public/html/images/account/btn-chg-gamepass-{countryLang}.png',
        chgPassword: '/public/html/images/account/btn-chg-pass-{countryLang}.png',
        referral: '/public/html/images/account/btn-referral-{countryLang}.png',
        profile: '/public/html/images/account/btn-profile-{countryLang}.png',
        deposit: '/public/html/images/account/btn-deposit-{countryLang}.png',
        withdraw: '/public/html/images/account/btn-withdraw-{countryLang}.png',
        transfer: '/public/html/images/account/btn-transfer-{countryLang}.png',
        history: '/public/html/images/account/btn-history-{countryLang}.png',
        profileHeader: '/public/html/images/account/header-profile-{countryLang}.png',
        profileBtnLogout: '/public/html/images/account/profile-btn-logout-{countryLang}.png',
        profileBtnChgPassword: '/public/html/images/account/profile-btn-chg-pass-{countryLang}.png',
        deleteIcon: '/public/html/images/icon/icon-delete.png',
    },
    LOGOUT_BTN: {
        CANCEL: '/public/html/images/icon/btn-logout-cancel-{countryLang}.png',
        CONFIRM: '/public/html/images/icon/btn-logout-confirm-{countryLang}.png',
    },
    REFERRAL: {
        overallTab: '/public/html/images/referral/refertab-overall-{countryLang}',
        memberTab: '/public/html/images/referral/refertab-member-{countryLang}',
        incomeTab: '/public/html/images/referral/refertab-income-{countryLang}',
        statisticsTab: '/public/html/images/referral/refertab-statistics-{countryLang}',
        shareBackground: '/public/html/images/referral/refer-share-background-{countryLang}.png',
        lineBtn: '/public/html/images/referral/referral-share-line-{countryLang}.png',
        facebookBtn: '/public/html/images/referral/referral-share-facebook-{countryLang}.png',
        copyBtn: '/public/html/images/referral/referral-share-copy-{countryLang}.png',
        incomeHeader: '/public/html/images/referral/refer-income-header-{countryLang}.png',
        contentBanner: '/public/html/images/referral/referral-content-banner-{countryLang}.jpg',
    },
    PAYMENT_METHOD: {
        eeziepay: {
            imgMobile: '/public/html/images/footer/ftr_pay_eezie_of_mobile.png',
        },
        help2pay: {
            imgMobile: '/public/html/images/footer/ftr_pay_h2p_of_mobile.png',
        },
        paytrust: {
            imgMobile: '/public/html/images/footer/ftr_pay_pt88_of_mobile.png',
        },
    },
    BANK_IMG: {
        MBB: {
            img: '/public/html/images/bank_img/bank-mbb_of.png',
            imgHover: '/public/html/images/bank_img/bank-mbb.png',
            imgMobile: '/public/html/images/bank_img/bank-mbb.png',
        },
        PBB: {
            img: '/public/html/images/bank_img/bank-pbb_of.png',
            imgHover: '/public/html/images/bank_img/bank-pbb.png',
            imgMobile: '/public/html/images/bank_img/bank-pbb.png',
        },
        CIMB: {
            img: '/public/html/images/bank_img/bank-cimb.png',
            imgHover: '/public/html/images/bank_img/bank-cimb_ov.png',
            imgMobile: '/public/html/images/bank_img/bank-cimb.png',
        },
        RHB: {
            img: '/public/html/images/bank_img/bank-rhb_of.png',
            imgHover: '/public/html/images/bank_img/bank-rhb.png',
            imgMobile: '/public/html/images/bank_img/bank-rhb.png',
        },
        HLB: {
            img: '/public/html/images/bank_img/bank-hlb_of.png',
            imgHover: '/public/html/images/bank_img/bank-hlb.png',
            imgMobile: '/public/html/images/bank_img/bank-hlb.png',
        },
    },
    infoCenter: {
        img1: '/public/html/images/promo1.png',
        img2: '/public/html/images/promo2.png',
        img3: '/public/html/images/promo3.png',
        img4: '/public/html/images/promo4.png',
        content: [
            {
                title: 'how to deposit',
                translation: 'global:infoCentre:option_2',
                url: '/help/how-to-deposit',
            },
            {
                title: 'how to withdraw',
                translation: 'global:infoCentre:option_3',
                url: '/help/how-to-withdraw',
            },
        ],
    },
    homeBankStatusImage: {
        img1: {
            en: ['/public/html/images/home_img/bankStatus1-en.png'],
            th: ['/public/html/images/home_img/bankStatus1-th.png'],
        },
        img2: {
            en: ['/public/html/images/home_img/bankStatus2-en.png'],
            th: ['/public/html/images/home_img/bankStatus2-th.png'],
        },
        img3: {
            en: ['/public/html/images/home_img/bankStatus3-en.png'],
            th: ['/public/html/images/home_img/bankStatus3-th.png'],
        },
        img4: {
            en: ['/public/html/images/home_img/bankStatus4-en.png'],
            th: ['/public/html/images/home_img/bankStatus4-th.png'],
        },
        visa: '/public/html/images/home_img/visa.png',
        master_card: '/public/html/images/home_img/master-card.png',
    },
    footerImg: {
        gaming: '/public/html/images/home_img/gaming_license.png',
        dbr: '/public/html/images/home_img/official_dbr.png',
        ambassaodor: '/public/html/images/home_img/ambassaodor.png',
        animation: '/public/html/images/home_img/footerAnimation.gif',
    },
    svgIndex: {
        register: '/public/html/images/common_img/register.svg',
        deposit: '/public/html/images/common_img/deposit.svg',
        rewards: '/public/html/images/common_img/rewards.svg',
        football: '/public/html/images/common_img/football.svg',
        hotgame: '/public/html/images/common_img/hotgame.svg',
        livecasino: '/public/html/images/common_img/livecasino.svg',
        video: '/public/html/images/common_img/video.svg',
        jackport: '/public/html/images/common_img/jackport.svg',
    },
    AMBASSADOR: {
        ambassador: '/public/html/images/footer/ambassaodor.png',
    },

    TEMPLATE_IMAGE_FORMAT: {
        submenu_icon: {
            ds1: 'svg',
        },
    },

    REFER_FRIEND_NOW: {
        fb: '/public/html/default_whitelabel/shared-image/icons/fb.png',
        line: '/public/html/default_whitelabel/shared-image/icons/line.png',
        mail: '/public/html/default_whitelabel/shared-image/icons/mail.png',
        telegram: '/public/html/default_whitelabel/shared-image/icons/telegram.png',
        whatsapp: '/public/html/default_whitelabel/shared-image/icons/watsapp.png',
    },

    SMALLBANNERSECTION: {
        homeSmallBanner_eng: ['/public/html/images/home_img/home-bottom-banner-en.jpg'],
        homeSmallBanner_zh: ['/public/html/images/home_img/home-bottom-banner-zh.jpg'],
        homeSmallBanner_ms: ['/public/html/images/home_img/home-bottom-banner-ms.jpg'],
        homeSmallBanner_th: ['/public/html/images/home_img/home-bottom-banner-th.jpg'],
    },
    SIDEBANNER: {
        award: '/public/html/images/home_img/side-banner-award.png',
        bannerJPG: '/public/html/images/sidebar/banner.jpg',
    },
    LIVE_STREAM: {
        ICON: '/public/html/images/home_img/maintenance-icon.png',
    },
    PROFILE: {
        submit: '/public/html/default_whitelabel/default-images/icon/submit.png',
        cancel: '/public/html/default_whitelabel/default-images/icon/cancel.png',
    },
    VIDEOBOTTOMBANNER: {
        homeVideoBottomBanner: ['/public/html/images/home_img/home-video-bottom-banner.jpg'],
    },
    champion_league: {
        champion_icon: '/public/html/images/home_img/champion-league-logo.png',
    },

    home_24hours: {
        home_24hours_icon: '/public/html/images/home_img/icon-24-7.png',
    },
    WALLET_ICON: {
        chat: '/public/html/images/home_img/ftrmenu-chat',
        deposit: '/public/html/images/home_img/deposit',
        funds: '/public/html/images/home_img/ftrmenu-funds',
        home: '/public/html/images/home_img/ftrmenu-home',
        promo: '/public/html/images/home_img/ftrmenu-promo',
        transfer: '/public/html/images/home_img/ftrmenu-transfer',
        vip: '/public/html/images/home_img/ftrmenu-vip',
        withdraw: '/public/html/images/home_img/ftrmenu-withdraw',
        logo: '/public/html/images/home_img/ftrmenu-dk7',
    },
    promotion: {
        defaultIMG: '/public/html/default_whitelabel/template/images/promotion-banner/default-promotion-banner.jpg',
    },
    deposit_icon: {
        VDP: '/public/html/default_whitelabel/shared-image/deposit-icon/vdp.png',
        MGPQR: '/public/html/default_whitelabel/shared-image/deposit-icon/mgpqr.png',
        MGP2P: '/public/html/default_whitelabel/shared-image/deposit-icon/mgp2p.png',
        ESP2P: '/public/html/default_whitelabel/shared-image/deposit-icon/esp2p.png',
        error: '/public/html/default_whitelabel/shared-image/deposit-icon/deposit_default.png',
    },
    EZ_WITHDRAWAL: {
        en: '/public/html/images/ez-withdrawal-en.png',
        zh: '/public/html/images/ez-withdrawal-cn.png',
        ms: '/public/html/images/ez-withdrawal-ms.png',
    },
    MOBILE_FUND: {
        en: '/public/html/images/ez-withdrawal-en.png',
        zh: '/public/html/images/ez-withdrawal-cn.png',
        ms: '/public/html/images/ez-withdrawal-ms.png',
    },
    MOBILE_EXTRA_PROFILE: {
        en: '/public/html/images/profile-extra-img-en.png',
        zh: '/public/html/images/profile-extra-img-cn.png',
        ms: '/public/html/images/profile-extra-img-ms.png',
    },
};

export default image;
